var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-23"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 372.97,
    y: 49.95,
    width: 79.27,
    height: 82.64,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.6,
    y: 49.95,
    width: 79.27,
    height: 82.64,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.9,132.61H367.58V49.93H446.9Zm-79.27-.05h79.22V50H367.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.26,
    y: 61.06,
    width: 57.96,
    height: 60.42,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.26,121.88a9.47,9.47,0,0,1-1.43,1.66c-.93,1-2.23,2.3-3.68,3.74s-2.8,2.71-3.79,3.62a9.32,9.32,0,0,1-1.68,1.4,9.35,9.35,0,0,1,1.43-1.66c.92-1,2.23-2.3,3.69-3.74s2.8-2.72,3.79-3.63A9.11,9.11,0,0,1,378.26,121.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.22,121.73a10.06,10.06,0,0,1,1.66,1.43c1,.93,2.3,2.23,3.74,3.69s2.71,2.79,3.62,3.78a9.32,9.32,0,0,1,1.4,1.68,9.35,9.35,0,0,1-1.66-1.43c-1-.92-2.3-2.23-3.74-3.69s-2.72-2.8-3.63-3.79A9.11,9.11,0,0,1,436.22,121.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.06,61.22a10.06,10.06,0,0,1,1.43-1.66c.93-1,2.23-2.3,3.69-3.74S444,53.11,445,52.2a9.32,9.32,0,0,1,1.68-1.4,9.35,9.35,0,0,1-1.43,1.66c-.92,1-2.22,2.3-3.69,3.74s-2.8,2.72-3.79,3.63A9.11,9.11,0,0,1,436.06,61.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.1,61.37a10.06,10.06,0,0,1-1.66-1.43c-1-.93-2.3-2.23-3.74-3.69s-2.71-2.79-3.62-3.78a9.32,9.32,0,0,1-1.4-1.68,9.35,9.35,0,0,1,1.66,1.43c1,.92,2.3,2.23,3.74,3.69s2.72,2.8,3.63,3.79A8.61,8.61,0,0,1,378.1,61.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.06,121.48s0-.11,0-.3,0-.48,0-.84c0-.76,0-1.85,0-3.26,0-2.86,0-7-.06-12.31,0-10.59-.07-25.66-.11-43.71l.22.22-57.79,0h0l.26-.26c0,22.18,0,42.92,0,60.42l-.22-.22,41.85.11,11.76.06,3.11,0,.8,0a1.23,1.23,0,0,1,.28,0h-1l-3.07,0-11.71.06-42,.11H378v-.22c0-17.5,0-38.24,0-60.42V60.8h.27l57.79,0h.23v.22c0,18.11-.08,33.23-.11,43.85,0,5.26,0,9.41-.06,12.26,0,1.4,0,2.47,0,3.22,0,.35,0,.62,0,.82A1.1,1.1,0,0,1,436.06,121.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.57,
    y: 81.6,
    width: 19.34,
    height: 19.34,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.68,
    y: 32.82,
    width: 57.66,
    height: 60.11,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.78,
    y: 32.82,
    width: 57.66,
    height: 60.11,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.46,93h-57.7V32.8h57.7Zm-57.66,0h57.63V32.84H273.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.53,
    y: 40.9,
    width: 42.16,
    height: 43.95,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.53,85.14a7.19,7.19,0,0,1-1,1.21c-.67.71-1.62,1.68-2.68,2.72s-2,2-2.75,2.64a6.65,6.65,0,0,1-1.22,1,6.45,6.45,0,0,1,1-1.2c.68-.71,1.62-1.68,2.69-2.73s2-2,2.76-2.64A6.84,6.84,0,0,1,281.53,85.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.69,85a6.16,6.16,0,0,1,1.21,1c.71.67,1.67,1.62,2.72,2.68s2,2,2.64,2.75a6.28,6.28,0,0,1,1,1.22,6.82,6.82,0,0,1-1.2-1c-.71-.67-1.68-1.62-2.73-2.68s-2-2-2.64-2.76A6.84,6.84,0,0,1,323.69,85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.58,41a6.16,6.16,0,0,1,1-1.21c.67-.71,1.62-1.67,2.68-2.72s2-2,2.75-2.63a6.15,6.15,0,0,1,1.22-1,6.66,6.66,0,0,1-1,1.21c-.68.71-1.63,1.67-2.69,2.72s-2,2-2.76,2.64A6.84,6.84,0,0,1,323.58,41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.42,41.13a7.19,7.19,0,0,1-1.21-1c-.71-.68-1.68-1.62-2.72-2.68s-2-2-2.64-2.76a6.28,6.28,0,0,1-1-1.22,7.27,7.27,0,0,1,1.2,1c.71.67,1.68,1.62,2.72,2.68s2,2,2.65,2.76A6.79,6.79,0,0,1,281.42,41.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.58,84.85a.67.67,0,0,1,0-.21c0-.15,0-.35,0-.62,0-.55,0-1.34,0-2.37,0-2.08,0-5.11,0-9,0-7.69-.05-18.66-.09-31.79l.17.16-42,0h0l.19-.19c0,16.13,0,31.22,0,43.95l-.16-.16,30.44.08,8.56,0,2.26,0h0l-2.23,0-8.51,0L281.53,85h-.16v-.16c0-12.73,0-27.82,0-43.95v-.19h.2l42,0h.16v.16c0,13.17-.06,24.18-.08,31.9,0,3.83,0,6.85-.05,8.92,0,1,0,1.8,0,2.34,0,.25,0,.45,0,.6S323.58,84.85,323.58,84.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.58,
    y: 55.84,
    width: 14.07,
    height: 14.07,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.78,378.66c5.14-2.66,11.21-3,16.93-2.06,3.07.51,6.27,1.43,8.36,3.73s2.48,6.37.09,8.35c-1.43,1.18-3.43,1.36-5.28,1.34-4.47,0-9.44-.84-13,1.85-2,1.54-3.4,4.09-5.84,4.85s-5.08-.67-6.35-2.82a9.9,9.9,0,0,1-.71-7.28A11.08,11.08,0,0,1,456.78,378.66Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445,355.88c3.15,4.5,9.27,3,12.1.26s4-6.72,5.13-10.51c2.5-8.67,5-17.77,3.16-26.59a14.75,14.75,0,0,0-3.4-7.23,7.7,7.7,0,0,0-7.31-2.44c-3.09.82-5,3.84-6.39,6.72a63.39,63.39,0,0,0-6.27,27.2c0,4.38.51,9,3,12.59",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.33,362.33c3.42-4.05,4.07-10,2.55-15.06s-5-9.4-8.92-12.93a48.27,48.27,0,0,0-16-9.43,17.13,17.13,0,0,0-7.19-1.22,7.55,7.55,0,0,0-6,3.65c-1.68,3.21-.07,7.09,1.68,10.27a122.06,122.06,0,0,0,10.49,16c3.14,4.05,6.74,8.05,11.54,9.89s9.77,1.61,12.31-1.71",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.76,423.72a9.24,9.24,0,0,0,.29-2c.14-1.49.33-3.36.54-5.58a78.76,78.76,0,0,1,1.26-8.18,62.65,62.65,0,0,1,3-9.65,35.38,35.38,0,0,1,4.93-8.74,18.38,18.38,0,0,1,6.23-5.18,17.67,17.67,0,0,1,5.25-1.64,9.55,9.55,0,0,0,2-.29,9.19,9.19,0,0,0-2.07,0,15.92,15.92,0,0,0-5.48,1.42,18.46,18.46,0,0,0-6.57,5.23A34.45,34.45,0,0,0,449,398a58.69,58.69,0,0,0-3,9.81,68.05,68.05,0,0,0-1.09,8.29c-.18,2.37-.25,4.28-.28,5.61A10.35,10.35,0,0,0,444.76,423.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.15,419.43a3.7,3.7,0,0,0,.05-.95v-2.71c0-2.35,0-5.76.12-10,.21-8.41.93-17.46,2.33-30.23,1.32-12,3.1-26,5-35q.6-3.1,1.19-5.55c.36-1.63.67-3,1-4.18s.47-1.94.63-2.63a3.85,3.85,0,0,0,.17-.94,4.21,4.21,0,0,0-.33.89l-.79,2.6c-.35,1.13-.71,2.53-1.11,4.15s-.88,3.47-1.32,5.54a308.53,308.53,0,0,0-5.23,32.51c-1.4,12.79-2,24.43-2.09,32.87-.05,4.21,0,7.62.15,10,.07,1.1.12,2,.16,2.71A3.9,3.9,0,0,0,445.15,419.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.2,397a17.47,17.47,0,0,0,0-2.83c-.1-1.82-.35-4.45-.86-7.67a102.83,102.83,0,0,0-2.5-11.18,92,92,0,0,0-4.67-13.23,70.34,70.34,0,0,0-13.74-21.39,35.6,35.6,0,0,0-3.23-3c-.49-.42-.93-.84-1.38-1.17l-1.25-.86a18.91,18.91,0,0,0-2.38-1.53c-.14.19,3.38,2.26,7.81,7a74.11,74.11,0,0,1,13.39,21.3,103.54,103.54,0,0,1,4.7,13.11c1.23,4.11,2,7.89,2.66,11.07s.92,5.79,1.13,7.6A20.59,20.59,0,0,0,445.2,397Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.5 436.59 425.75 467.42 465.35 467.42 467.61 436.59 423.5 436.59",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.67,
    y: 424.44,
    width: 52.66,
    height: 12.15,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.67 466.24 419.67 469.61 422.15 469.61 471.46 469.61 471.46 466.24 419.67 466.24",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.57 475.54 422.15 469.61 469.57 469.61 466.74 475.54 424.57 475.54",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.87,446.66s-.05.11-.19.29-.35.46-.59.78l-2.3,3-.11.13-.1-.14-5.66-7.84h.32c-1.68,2.39-3.56,5.05-5.58,7.9l-.17.25-.2-.23-6.62-7.88h.38l-.36.45c-2.05,2.58-4,5.07-5.92,7.42l-.2.25-.18-.26-5.58-7.9.32,0-6.87,7.83-.13.14-.09-.15-2.15-3.62c-.23-.39-.41-.71-.55-1a1.14,1.14,0,0,1-.17-.35,1.85,1.85,0,0,1,.23.31l.61.92,2.26,3.56-.22,0,6.77-7.93.17-.2.16.21,5.63,7.87h-.38l5.9-7.43.37-.46.19-.24.19.24c2.32,2.76,4.55,5.43,6.6,7.89h-.37c2-2.84,3.93-5.49,5.64-7.86l.16-.23.16.23,5.55,7.92h-.2l2.4-2.88.64-.75A2.12,2.12,0,0,1,466.87,446.66Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.16,436.39c0,.13-9.93.24-22.17.24s-22.16-.11-22.16-.24,9.92-.25,22.16-.25S468.16,436.25,468.16,436.39Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.16,469.94c0,.14-10.79.25-24.09.25s-24.09-.11-24.09-.25,10.78-.25,24.09-.25S470.16,469.8,470.16,469.94Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.68 452.21 151.68 474.91 184.88 474.91 221.49 474.91 221.49 452.21 151.68 452.21",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.75 445.86 148.75 452.21 223.93 452.21 223.93 445.86 184.88 445.86 148.75 445.86",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.34 474.91 221.49 474.91 221.49 452.21 223.93 452.21 223.93 445.86 184.88 445.86 184.88 451.62 186.34 474.91",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.45,
    y: 455.87,
    width: 14.16,
    height: 3.42,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.62,
    y: 463.56,
    width: 18.18,
    height: 7.22,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.5 445.99 210.5 475.54 253.72 475.54 301.38 475.54 301.38 445.99 210.5 445.99",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.69 437.72 206.69 445.99 304.56 445.99 304.56 437.72 253.72 437.72 206.69 437.72",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.62 475.54 301.38 475.54 301.38 445.99 304.56 445.99 304.56 437.72 253.72 437.72 253.72 445.22 255.62 475.54",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.21,
    y: 450.75,
    width: 18.43,
    height: 4.45,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.84,
    y: 460.76,
    width: 23.66,
    height: 9.39,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.94 415.02 220.94 437.72 254.13 437.72 290.74 437.72 290.74 415.02 220.94 415.02",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.01 408.68 218.01 415.02 293.18 415.02 293.18 408.68 254.13 408.68 218.01 408.68",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.59 437.72 290.74 437.72 290.74 415.02 293.18 415.02 293.18 408.68 254.13 408.68 254.13 414.44 255.59 437.72",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.7,
    y: 418.68,
    width: 14.16,
    height: 3.42,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.88,
    y: 426.37,
    width: 18.18,
    height: 7.22,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.23,370.75l-95.6-.06a20.83,20.83,0,0,1-20.82-20.83l.05-239.68A20.82,20.82,0,0,1,309.7,89.36l95.6,0a20.83,20.83,0,0,1,20.82,20.83l-.05,239.68A20.83,20.83,0,0,1,405.23,370.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.2,97.89H386.67a4.61,4.61,0,0,0-4.51,4.7v3.36a4.61,4.61,0,0,1-4.5,4.71l-36.13,0a4.62,4.62,0,0,1-4.5-4.71v-3.36a4.61,4.61,0,0,0-4.5-4.71H309.79a14.59,14.59,0,0,0-14.59,14.59l-.05,233.94A14.58,14.58,0,0,0,309.73,361l95.41.06a14.59,14.59,0,0,0,14.59-14.58l0-233.95A14.59,14.59,0,0,0,405.2,97.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.38,98.08h.5a11,11,0,0,1,1.49.11,14,14,0,0,1,5.49,1.9,13.69,13.69,0,0,1,3.33,2.71,14.4,14.4,0,0,1,2.79,4.36,15.26,15.26,0,0,1,1.1,5.94V120c0,19.5,0,47.7.05,82.56s0,76.35,0,122.43v21.93a15.4,15.4,0,0,1-.56,4.47,15,15,0,0,1-1.86,4.12,16.08,16.08,0,0,1-3.05,3.38,14.79,14.79,0,0,1-8.45,3.28c-3.07.09-6.12,0-9.2,0H378.4l-38.25,0H310.71a15.47,15.47,0,0,1-9.52-2.63,15,15,0,0,1-5.81-8,16.32,16.32,0,0,1-.61-5v-4.94q0-9.84,0-19.56,0-19.43,0-38.26c0-25.07,0-49.27,0-72.31s0-44.94,0-65.44c0-10.24,0-20.14,0-29.65v-3.55c0-.59.05-1.19.08-1.78s.15-1.17.3-1.74a14.8,14.8,0,0,1,8.5-10.26,15.49,15.49,0,0,1,6.51-1.23l12.75,0h9.15a4.69,4.69,0,0,1,2.88.8,5,5,0,0,1,1.79,2.35,7.94,7.94,0,0,1,.29,2.89v1.43a10.64,10.64,0,0,0,.05,1.39,4.57,4.57,0,0,0,1.09,2.45,4.27,4.27,0,0,0,2.24,1.39,4.78,4.78,0,0,0,1.31.13h6.63l19.3,0h8.5c.67,0,1.36,0,2,0a4.51,4.51,0,0,0,1.79-.63,4.67,4.67,0,0,0,2.05-2.95,8.16,8.16,0,0,0,.11-1.78c0-.59,0-1.17,0-1.75a9.64,9.64,0,0,1,.07-1.7,5.23,5.23,0,0,1,.55-1.57,4.65,4.65,0,0,1,2.34-2.07,7.49,7.49,0,0,1,2.91-.31l9.49,0,5.83,0,2,0h-2l-5.83,0-9.49,0a7.15,7.15,0,0,0-2.86.31,4.45,4.45,0,0,0-2.26,2,4.66,4.66,0,0,0-.53,1.52,9.33,9.33,0,0,0-.07,1.68v1.75a8.55,8.55,0,0,1-.11,1.81,4.85,4.85,0,0,1-2.12,3.06,4.56,4.56,0,0,1-1.86.66c-.68.06-1.34,0-2,0H341.81a5.35,5.35,0,0,1-1.37-.13,4.6,4.6,0,0,1-2.37-1.47,4.87,4.87,0,0,1-1.15-2.57,9.87,9.87,0,0,1-.05-1.43v-1.43a7.52,7.52,0,0,0-.29-2.8,4.58,4.58,0,0,0-1.69-2.22,4.43,4.43,0,0,0-2.73-.75h-21.9a14.5,14.5,0,0,0-14.71,11.26c-.14.56-.19,1.14-.29,1.71s-.07,1.15-.08,1.74v33.2c0,20.5,0,42.4,0,65.44v72.31q0,18.81,0,38.26v24.5a15.69,15.69,0,0,0,.59,4.83,14.55,14.55,0,0,0,5.64,7.79,15.08,15.08,0,0,0,9.29,2.56h9.88l19.56,0,38.25,0H397c3.07,0,6.15.05,9.17,0a14.5,14.5,0,0,0,8.23-3.19,15.81,15.81,0,0,0,3-3.3,14.52,14.52,0,0,0,1.82-4,15.2,15.2,0,0,0,.54-4.36c0-1.48,0-3,0-4.43V325c0-46.08.05-87.58.07-122.43s.06-63.06.08-82.56q0-3.66,0-6.9a15,15,0,0,0-1.06-5.89,14.73,14.73,0,0,0-2.75-4.34,14.3,14.3,0,0,0-3.31-2.71,13.85,13.85,0,0,0-5.45-1.92,11.9,11.9,0,0,0-1.48-.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.21,121.77c0,.07-2.42.14-5.4.16s-5.4,0-5.4-.07,2.42-.13,5.4-.16S408.21,121.71,408.21,121.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.23,124.54c0,.06-2.41.13-5.4.16s-5.4,0-5.4-.07,2.42-.14,5.4-.16S408.23,124.47,408.23,124.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.26,127.3c0,.06-2.42.13-5.4.16s-5.41,0-5.41-.07,2.42-.13,5.41-.16S408.26,127.24,408.26,127.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,130.46a1,1,0,0,1,.22,0l.63,0,2.3,0-.06.06c0-.51,0-1.07,0-1.67a7.94,7.94,0,0,1,0-1,.89.89,0,0,1,.77-.71c.37,0,.7,0,1.1,0a.9.9,0,0,1,.76.89c0,.78,0,1.59,0,2.44l-.11-.11,2.91,0-.11.12c0-1.18,0-2.39,0-3.63v-.92a.94.94,0,0,0-.41-.69l-1.27-1.25-1.23-1.22-.6-.58a1.32,1.32,0,0,0-.6-.45.8.8,0,0,0-.67.13c-.17.14-.36.36-.54.53l-1,1c-.66.68-1.34,1.31-1.84,1.9a2.08,2.08,0,0,0-.15,1.08v1c0,.63,0,1.18,0,1.65s0,.77,0,1.06,0,.37,0,.38a1.35,1.35,0,0,1,0-.35c0-.29,0-.63,0-1s0-1,0-1.67c0-.33,0-.68,0-1,0-.19,0-.38,0-.58a1.24,1.24,0,0,1,.16-.61c.54-.65,1.18-1.24,1.84-1.94l1-1.06c.19-.19.34-.37.56-.56a1,1,0,0,1,.85-.16,1.53,1.53,0,0,1,.69.49l.6.59,1.23,1.21c.42.41.85.82,1.28,1.25a2.78,2.78,0,0,1,.32.35.88.88,0,0,1,.15.49c0,.31,0,.62,0,.93,0,1.24,0,2.45,0,3.62v.12h-.11l-2.91,0h-.11v-.11c0-.84,0-1.66,0-2.44a.71.71,0,0,0-.59-.71c-.33,0-.73,0-1.05,0a.71.71,0,0,0-.63.57c0,.29,0,.63,0,.93v1.73H310Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.6,
    y: 237.41,
    width: 82.36,
    height: 16.82,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.6,
    y: 261.82,
    width: 82.36,
    height: 16.82,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,312.54H337.62a8.41,8.41,0,0,1-8.41-8.42h0a8.41,8.41,0,0,1,8.41-8.41H379a8.42,8.42,0,0,1,8.41,8.41h0A8.42,8.42,0,0,1,379,312.54Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,249.52h-3.64a.64.64,0,0,1-.64-.64h0a2.42,2.42,0,0,1,2.42-2.43h.08a2.43,2.43,0,0,1,2.43,2.43h0A.65.65,0,0,1,327,249.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.6,245.18a1.45,1.45,0,1,1-1.45-1.45A1.45,1.45,0,0,1,326.6,245.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.98,
    y: 270.5,
    width: 4.34,
    height: 3.07,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.81,271.15h-1.46v-.95a1.23,1.23,0,0,0-2.46,0v.95h-1.45v-.95a2.69,2.69,0,0,1,5.37,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,322.84v1.46h1.91v.34H335v1.57h-.39V322.5h2.54v.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.49,324.81a1.37,1.37,0,0,1,1.42-1.41,1.42,1.42,0,0,1,0,2.83A1.38,1.38,0,0,1,337.49,324.81Zm2.45,0a1,1,0,1,0-2.07,0,1,1,0,1,0,2.07,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.49,323.4v.37h-.09c-.58,0-.93.37-.93,1v1.42h-.38v-2.79h.36V324A1.06,1.06,0,0,1,342.49,323.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.72,323.42v2.45a1.22,1.22,0,0,1-1.39,1.39,1.92,1.92,0,0,1-1.3-.43l.19-.28a1.72,1.72,0,0,0,1.1.38c.71,0,1-.33,1-1v-.36a1.25,1.25,0,0,1-1.09.54,1.35,1.35,0,1,1,0-2.7,1.24,1.24,0,0,1,1.1.56v-.54Zm-.36,1.33a1.06,1.06,0,1,0-1.06,1A1,1,0,0,0,345.36,324.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.49,324.81a1.42,1.42,0,1,1,1.42,1.42A1.37,1.37,0,0,1,346.49,324.81Zm2.46,0a1,1,0,1,0-1,1.09A1,1,0,0,0,349,324.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.56,326a.91.91,0,0,1-.59.19.73.73,0,0,1-.81-.81v-1.68h-.5v-.32h.5v-.61h.37v.61h.85v.32h-.85v1.66a.45.45,0,0,0,.49.51.66.66,0,0,0,.41-.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.45,324.81a1.34,1.34,0,0,1-1.38,1.42,1.21,1.21,0,0,1-1.06-.55v1.55h-.38v-3.81H354V324a1.23,1.23,0,0,1,1.08-.57A1.34,1.34,0,0,1,356.45,324.81Zm-.37,0a1,1,0,1,0-1,1.09A1,1,0,0,0,356.08,324.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.31,324.48v1.73H359v-.44a1,1,0,0,1-1,.46c-.63,0-1-.32-1-.81s.28-.78,1.08-.78h.88v-.17c0-.48-.27-.74-.79-.74a1.44,1.44,0,0,0-.93.33l-.17-.28a1.78,1.78,0,0,1,1.14-.38A1,1,0,0,1,359.31,324.48Zm-.38.89v-.45h-.87c-.54,0-.72.21-.72.49s.26.53.71.53A.89.89,0,0,0,358.93,325.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.94,325.89l.17-.3a1.65,1.65,0,0,0,1,.32c.53,0,.75-.18.75-.46,0-.73-1.81-.15-1.81-1.25,0-.46.39-.8,1.1-.8a1.91,1.91,0,0,1,1,.26l-.17.3a1.41,1.41,0,0,0-.82-.24c-.5,0-.72.2-.72.46,0,.76,1.8.19,1.8,1.26,0,.48-.42.79-1.15.79A1.83,1.83,0,0,1,359.94,325.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.53,325.89l.17-.3a1.65,1.65,0,0,0,1,.32c.53,0,.75-.18.75-.46,0-.73-1.81-.15-1.81-1.25,0-.46.39-.8,1.1-.8a1.91,1.91,0,0,1,1,.26l-.17.3a1.41,1.41,0,0,0-.82-.24c-.5,0-.72.2-.72.46,0,.76,1.8.19,1.8,1.26,0,.48-.42.79-1.15.79A1.83,1.83,0,0,1,362.53,325.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.54,323.42l-1.06,2.79h-.35l-.88-2.28-.88,2.28H366l-1-2.79h.36l.87,2.37.9-2.37h.32l.89,2.37.88-2.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.74,324.81a1.42,1.42,0,1,1,1.42,1.42A1.37,1.37,0,0,1,369.74,324.81Zm2.45,0a1,1,0,0,0-1-1.08,1.09,1.09,0,0,0,0,2.17A1,1,0,0,0,372.19,324.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.75,323.4v.37h-.09a.9.9,0,0,0-.94,1v1.42h-.38v-2.79h.36V324A1.06,1.06,0,0,1,374.75,323.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.94,322.28v3.93h-.36v-.55a1.23,1.23,0,0,1-1.08.57,1.42,1.42,0,0,1,0-2.83,1.21,1.21,0,0,1,1.06.55v-1.67Zm-.37,2.53a1,1,0,1,0-1,1.09A1,1,0,0,0,377.57,324.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.67,323.45c0-.38-.31-.65-.85-.65a1.23,1.23,0,0,0-1,.43l-.28-.21a1.63,1.63,0,0,1,1.32-.55c.74,0,1.22.35,1.22.92,0,.91-1,.95-1,1.71h-.39C379.71,324.22,380.67,324.14,380.67,323.45Zm-1,2.51a.28.28,0,1,1,.27.27A.27.27,0,0,1,379.63,326Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.5,219.59v6.91h-.81l-4.14-5.15v5.15h-1v-6.91h.81l4.14,5.15v-5.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.27,219.65a.64.64,0,0,1,1.28,0,.62.62,0,0,1-.64.63A.61.61,0,0,1,339.27,219.65Zm.17,1.62h.94v5.23h-.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.7,223.88a2.61,2.61,0,0,1,2.77-2.66,2.32,2.32,0,0,1,2.13,1.11l-.72.47a1.62,1.62,0,0,0-1.42-.75,1.84,1.84,0,0,0,0,3.68,1.64,1.64,0,0,0,1.42-.75l.72.45a2.33,2.33,0,0,1-2.13,1.13A2.63,2.63,0,0,1,341.7,223.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.79,224.06l-1.09,1v1.43h-.95v-7.33h.95v4.7l2.86-2.6h1.14l-2.2,2.16,2.42,3.07h-1.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.69,223.49v3H358v-2.94a1.45,1.45,0,0,0-1.56-1.66,1.71,1.71,0,0,0-1.82,1.87v2.73h-.7v-5.19h.67v.95a2.19,2.19,0,0,1,2-1A2,2,0,0,1,358.69,223.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.51,223.28v3.22h-.67v-.81a1.94,1.94,0,0,1-1.78.86c-1.18,0-1.9-.61-1.9-1.51s.51-1.47,2-1.47h1.65v-.32c0-.89-.5-1.37-1.47-1.37a2.69,2.69,0,0,0-1.73.61l-.31-.52a3.25,3.25,0,0,1,2.11-.7A1.84,1.84,0,0,1,364.51,223.28Zm-.7,1.66v-.85h-1.63c-1,0-1.33.4-1.33.93s.49,1,1.31,1A1.66,1.66,0,0,0,363.81,224.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,223.49v3h-.7v-2.94c0-1.1-.56-1.66-1.49-1.66a1.67,1.67,0,0,0-1.74,1.87v2.73h-.7v-2.94c0-1.1-.56-1.66-1.5-1.66a1.67,1.67,0,0,0-1.74,1.87v2.73h-.7v-5.19h.67v.94a2.09,2.09,0,0,1,1.9-1,1.86,1.86,0,0,1,1.85,1.09,2.27,2.27,0,0,1,2.06-1.09A2,2,0,0,1,375,223.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.43,224.12h-4.34a1.92,1.92,0,0,0,2,1.81,2.06,2.06,0,0,0,1.59-.68l.39.45a2.74,2.74,0,0,1-4.72-1.8,2.53,2.53,0,1,1,5.05,0C381.44,224,381.43,224,381.43,224.12Zm-4.34-.52h3.68a1.84,1.84,0,0,0-3.68,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.71,334.34l.18-.37a1.77,1.77,0,0,0,1.11.38c.58,0,.83-.22.83-.51,0-.82-2-.3-2-1.55,0-.52.4-1,1.28-1a2,2,0,0,1,1.08.3L352,332a1.78,1.78,0,0,0-.92-.27c-.57,0-.82.24-.82.53,0,.82,2,.31,2,1.54,0,.51-.42.95-1.3.95A2,2,0,0,1,349.71,334.34Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.85,331.4a.31.31,0,0,1,.62,0,.31.31,0,0,1-.31.31A.3.3,0,0,1,352.85,331.4Zm.08.78h.46v2.54h-.46Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.7,332.18v2.2a1.15,1.15,0,0,1-1.32,1.3,1.88,1.88,0,0,1-1.21-.38l.22-.35a1.56,1.56,0,0,0,1,.33c.6,0,.87-.28.87-.85v-.2a1.17,1.17,0,0,1-.91.39,1.23,1.23,0,1,1,0-2.46,1.14,1.14,0,0,1,.93.42v-.4Zm-.45,1.21a.81.81,0,0,0-.87-.83.83.83,0,1,0,.87.83Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,333.26v1.46h-.46v-1.4c0-.5-.25-.75-.68-.75a.76.76,0,0,0-.81.85v1.3h-.46v-2.54H358v.39a1.09,1.09,0,0,1,.92-.41A1,1,0,0,1,360,333.26Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.51,332.18v2.54h-.44v-.38a1,1,0,0,1-.86.41,1,1,0,0,1-1.09-1.1v-1.47h.46v1.41c0,.5.24.75.68.75a.75.75,0,0,0,.79-.84v-1.32Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368,333.45a1.23,1.23,0,0,1-1.29,1.3,1.08,1.08,0,0,1-.88-.41v1.31h-.46v-3.47h.44v.41a1.05,1.05,0,0,1,.9-.43A1.23,1.23,0,0,1,368,333.45Zm-.47,0a.86.86,0,1,0-.85.9A.84.84,0,0,0,367.55,333.45Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.06,305.18l.22-.49a1.8,1.8,0,0,0,1.1.37c.52,0,.74-.18.74-.43,0-.73-2-.25-2-1.5,0-.54.43-1,1.35-1a2.12,2.12,0,0,1,1.12.3l-.2.48a1.92,1.92,0,0,0-.92-.26c-.52,0-.73.2-.73.45,0,.72,2,.25,2,1.49,0,.53-.44,1-1.36,1A2.16,2.16,0,0,1,350.06,305.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.22,302.19a.39.39,0,0,1,.77,0,.37.37,0,0,1-.39.37A.36.36,0,0,1,353.22,302.19Zm.08.78h.6v2.56h-.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.23,303v2.18a1.21,1.21,0,0,1-1.38,1.35,2.06,2.06,0,0,1-1.25-.37l.27-.45a1.54,1.54,0,0,0,.95.31c.56,0,.81-.26.81-.78v-.13a1.12,1.12,0,0,1-.86.34,1.22,1.22,0,0,1-1.29-1.24,1.21,1.21,0,0,1,1.29-1.23,1.12,1.12,0,0,1,.89.36V303Zm-.59,1.21a.78.78,0,1,0-.78.73A.73.73,0,0,0,356.64,304.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.54,304.07v1.46h-.6v-1.39c0-.45-.23-.67-.61-.67a.68.68,0,0,0-.71.77v1.29H358V303h.57v.34a1.09,1.09,0,0,1,.88-.36A1,1,0,0,1,360.54,304.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.55,302.19a.39.39,0,0,1,.77,0,.37.37,0,0,1-.39.37A.36.36,0,0,1,362.55,302.19Zm.08.78h.6v2.56h-.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.54,304.07v1.46h-.6v-1.39c0-.45-.23-.67-.61-.67a.68.68,0,0,0-.72.77v1.29H364V303h.57v.34a1.08,1.08,0,0,1,.88-.36A1,1,0,0,1,366.54,304.07Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Prototyping--inject-23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.07,115H212.84a4.28,4.28,0,0,0-4.19,4.38v3.12a4.29,4.29,0,0,1-4.19,4.38l-33.6,0a4.29,4.29,0,0,1-4.19-4.38v-3.13a4.29,4.29,0,0,0-4.18-4.38H141.34a13.56,13.56,0,0,0-13.57,13.56l0,217.58a13.57,13.57,0,0,0,13.56,13.57l88.74.05a13.57,13.57,0,0,0,13.57-13.56l0-217.58A13.57,13.57,0,0,0,230.07,115Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.07,115l.47,0a10.45,10.45,0,0,1,1.37.1,12.94,12.94,0,0,1,5.09,1.76,13.1,13.1,0,0,1,3.1,2.51,13.6,13.6,0,0,1,2.58,4,14.06,14.06,0,0,1,1,5.51v6.39c0,18.08,0,44.22.05,76.54s0,70.78,0,113.5v20.33a14.88,14.88,0,0,1-.52,4.14,13.86,13.86,0,0,1-1.73,3.82,14.59,14.59,0,0,1-2.83,3.14,13.7,13.7,0,0,1-7.83,3c-2.85.08-5.67,0-8.53,0H205.06l-35.46,0H142.31a14.34,14.34,0,0,1-8.83-2.44,13.83,13.83,0,0,1-5.38-7.43,14.87,14.87,0,0,1-.57-4.59v-4.57q0-9.13,0-18.14,0-18,0-35.46c0-23.25,0-45.68,0-67s0-41.67,0-60.67q0-14.25,0-27.49v-3.29c0-.55,0-1.1.08-1.65s.13-1.09.27-1.61a13.79,13.79,0,0,1,2.86-5.75,14,14,0,0,1,5-3.76,14.17,14.17,0,0,1,6-1.14h20.3a4.31,4.31,0,0,1,2.67.75,4.54,4.54,0,0,1,1.66,2.18,7.21,7.21,0,0,1,.27,2.68v1.32a11,11,0,0,0,0,1.29,4.33,4.33,0,0,0,1,2.27,4,4,0,0,0,2.07,1.29,5,5,0,0,0,1.22.12h6.15l17.88,0h7.89c.62,0,1.26,0,1.85,0a4.07,4.07,0,0,0,1.66-.58,4.32,4.32,0,0,0,1.9-2.74,8.18,8.18,0,0,0,.11-1.64v-1.63a9.29,9.29,0,0,1,.07-1.58,4.55,4.55,0,0,1,.51-1.45,4.24,4.24,0,0,1,2.17-1.91,6.78,6.78,0,0,1,2.69-.29l8.8,0,5.41,0,1.84,0s-.62,0-1.84,0l-5.41,0H214a6.69,6.69,0,0,0-2.65.29,4.19,4.19,0,0,0-2.09,1.86,4.53,4.53,0,0,0-.5,1.42,8.82,8.82,0,0,0-.06,1.55v1.63a8,8,0,0,1-.1,1.68,4.49,4.49,0,0,1-2,2.83,4.13,4.13,0,0,1-1.72.61c-.63.06-1.24,0-1.87,0H171.14a5.09,5.09,0,0,1-1.28-.12,4.25,4.25,0,0,1-2.19-1.36A4.58,4.58,0,0,1,166.6,123a9.8,9.8,0,0,1,0-1.32V120.4a7.28,7.28,0,0,0-.27-2.6,4.23,4.23,0,0,0-1.57-2.06,4,4,0,0,0-2.53-.7h-20.3A13.49,13.49,0,0,0,131,119.85a13.54,13.54,0,0,0-2.78,5.63c-.14.52-.18,1-.27,1.58s-.07,1.07-.08,1.62V132q0,13.23,0,27.49V345.34a14.7,14.7,0,0,0,.56,4.48,13.46,13.46,0,0,0,5.22,7.22,14,14,0,0,0,8.62,2.38H169.6l35.46,0h17.27c2.85,0,5.71,0,8.51,0a13.33,13.33,0,0,0,7.62-2.95,14.29,14.29,0,0,0,2.75-3.06,13.16,13.16,0,0,0,1.69-3.72,14.09,14.09,0,0,0,.51-4v-4.11q0-8.21,0-16.22c0-42.72,0-81.19.06-113.5s.06-58.46.07-76.54V128.9a13.55,13.55,0,0,0-3.53-9.5,13.19,13.19,0,0,0-3.07-2.5,13,13,0,0,0-5.05-1.79,9.67,9.67,0,0,0-1.37-.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.82,135.34a39.9,39.9,0,0,1-6.38.26,40,40,0,0,1-6.39-.26,40,40,0,0,1,6.39-.26A39.9,39.9,0,0,1,231.82,135.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.51,137.45a40,40,0,0,1-6.39.26,40,40,0,0,1-6.39-.26,38.62,38.62,0,0,1,6.39-.26A38.62,38.62,0,0,1,230.51,137.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.16,139.42a39.8,39.8,0,0,1-6.38.26,40,40,0,0,1-6.39-.26,40,40,0,0,1,6.39-.26A39.8,39.8,0,0,1,231.16,139.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.86,155.86l.48.14,1.39.49c.59.24,1.33.56,2.18,1a29.94,29.94,0,0,1,2.82,1.63,30.82,30.82,0,0,1,6.69,5.9,31.3,31.3,0,0,1,3.19,4.58c.53.84.94,1.78,1.41,2.71s.83,1.95,1.14,3a28.68,28.68,0,0,1,.9,14.22,31.87,31.87,0,0,1-7,14.78,29.48,29.48,0,0,1-6.71,5.88,30.92,30.92,0,0,1-8.52,3.74,32.85,32.85,0,0,1-19.32-.72,31.68,31.68,0,0,1-15.26-11.87,33.07,33.07,0,0,1-5.92-17.05,28.84,28.84,0,0,1,3.72-15.9,26,26,0,0,1,10.39-9.72,34.37,34.37,0,0,1,11.24-3.59,46.86,46.86,0,0,1,8.92-.4,50.75,50.75,0,0,1,7.55.87l-.5-.05-1.45-.18c-1.28-.14-3.17-.35-5.61-.44a48.7,48.7,0,0,0-8.86.48A34.25,34.25,0,0,0,167.63,159a25.66,25.66,0,0,0-10.2,9.61,28.42,28.42,0,0,0-3.61,15.65A32.6,32.6,0,0,0,159.68,201a31.14,31.14,0,0,0,15,11.66,32.34,32.34,0,0,0,19,.73,29.51,29.51,0,0,0,15-9.44,31.65,31.65,0,0,0,6.94-14.55,28.42,28.42,0,0,0-.83-14c-.3-1-.73-2-1.11-3s-.86-1.85-1.37-2.69a31,31,0,0,0-12.49-12.13c-.84-.41-1.56-.75-2.15-1l-1.37-.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.76,197a2,2,0,0,1-.24-.51l-.6-1.49c-.51-1.29-1.23-3.18-2.33-5.4a23.43,23.43,0,0,0-5.07-7,15.62,15.62,0,0,0-4.24-2.77,11.65,11.65,0,0,0-5.3-.92,14.94,14.94,0,0,0-9.32,4.44,21.17,21.17,0,0,0-4.59,7.28,35.26,35.26,0,0,0-1.64,5.64c-.13.63-.23,1.15-.32,1.57a2.72,2.72,0,0,1-.13.54,2,2,0,0,1,0-.56c0-.36.11-.9.22-1.59a30.78,30.78,0,0,1,1.5-5.73,21,21,0,0,1,4.59-7.49,15.32,15.32,0,0,1,9.62-4.62,12,12,0,0,1,5.54,1,15.55,15.55,0,0,1,4.36,2.89,23,23,0,0,1,5.08,7.17,52.35,52.35,0,0,1,2.19,5.49c.21.62.37,1.12.51,1.53A4.22,4.22,0,0,1,203.76,197Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.76,164.86s.13,0,.38,0a4,4,0,0,1,1,.29,6.16,6.16,0,0,1,3.65,5.27,5.42,5.42,0,0,1-.81,3.06,6.4,6.4,0,0,1-6.25,3,6.58,6.58,0,0,1-5.09-4.75,5.83,5.83,0,0,1,0-3.16A6.57,6.57,0,0,1,181,166.2a6.7,6.7,0,0,1,3.3-2.1,4.23,4.23,0,0,1,1.06-.16c.24,0,.37,0,.37,0s-.51.07-1.37.35a6.57,6.57,0,0,0-3.07,2.14,6.26,6.26,0,0,0-1.19,2.28,5.37,5.37,0,0,0,0,2.92,6.11,6.11,0,0,0,4.7,4.37,6,6,0,0,0,5.77-2.76,5,5,0,0,0,.78-2.79,5.73,5.73,0,0,0-.66-2.48,6,6,0,0,0-2.65-2.62C187.27,165,186.75,164.92,186.76,164.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,233.87a3,3,0,0,1-.7-.24c-.45-.17-1.13-.4-2-.64a19.29,19.29,0,0,0-7.65-.45,18.33,18.33,0,0,0-5.09,1.49c-.87.39-1.75.87-2.73,1.25a5.32,5.32,0,0,1-3.25.37c-2.46-.64-2.82-3.86-5-4.28-1.07-.23-2.07.56-2.87,1.42a19.7,19.7,0,0,1-2.69,2.62,4.36,4.36,0,0,1-1.85.71,4.28,4.28,0,0,1-1.92-.29,12.41,12.41,0,0,1-3.1-2,26.41,26.41,0,0,0-2.77-2,4.44,4.44,0,0,0-3-.72,4.22,4.22,0,0,0-2.5,1.56c-.67.76-1.22,1.59-1.84,2.35a6.75,6.75,0,0,1-2.18,1.85,5.75,5.75,0,0,1-2.59.56,5.34,5.34,0,0,1-4-1.86,5.61,5.61,0,0,1-1.25-3.14,5,5,0,0,1,.27-2.11,2.61,2.61,0,0,1,.32-.67,5.93,5.93,0,0,0-.39,2.76,5.52,5.52,0,0,0,1.27,3,5.09,5.09,0,0,0,3.81,1.68,5.32,5.32,0,0,0,2.4-.55,6.13,6.13,0,0,0,2-1.77c.6-.73,1.15-1.58,1.83-2.37a4.67,4.67,0,0,1,2.77-1.73,4.85,4.85,0,0,1,3.34.76,24.61,24.61,0,0,1,2.83,2.06,11.64,11.64,0,0,0,3,1.88,3.73,3.73,0,0,0,1.68.26,3.84,3.84,0,0,0,1.61-.62,19.68,19.68,0,0,0,2.62-2.55,7.06,7.06,0,0,1,1.44-1.21,2.83,2.83,0,0,1,1.89-.36,3,3,0,0,1,1.65.9,10.46,10.46,0,0,1,1.09,1.38,4.57,4.57,0,0,0,2.34,2.05,4.84,4.84,0,0,0,2.95-.34c1-.35,1.83-.82,2.72-1.22a18.17,18.17,0,0,1,5.22-1.45,18.75,18.75,0,0,1,7.76.61,16.73,16.73,0,0,1,2,.74A5.91,5.91,0,0,1,217,233.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.74,242.86c0,.15-6.45.26-14.41.26s-14.4-.11-14.4-.26,6.44-.26,14.4-.26S201.74,242.72,201.74,242.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.49,278.24a77.62,77.62,0,0,1-.12-9.12,80.53,80.53,0,0,1,.41-9.12,82.23,82.23,0,0,1,.11,9.13A82,82,0,0,1,141.49,278.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.37,279.06c0,.14-19.85-.06-44.32-.45s-44.32-.82-44.31-1,19.84.06,44.32.45S228.37,278.91,228.37,279.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,258.68c0,.15-19.19.56-42.85.92s-42.86.53-42.86.39,19.18-.55,42.85-.91S228,258.54,228,258.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.64,278.61a94.84,94.84,0,0,1-.26-10,94.84,94.84,0,0,1,.26-10,98.18,98.18,0,0,1,.26,10A98.18,98.18,0,0,1,227.64,278.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.84,266.64a1,1,0,0,1,.61.05,2.68,2.68,0,0,1,1.33,1,2.94,2.94,0,0,1,.49,2.44,2.91,2.91,0,0,1-5.13.65,3,3,0,0,1-.14-2.49,2.67,2.67,0,0,1,1.05-1.3c.34-.2.57-.22.57-.19a3.26,3.26,0,0,0-1.27,1.62,2.65,2.65,0,0,0,.2,2.11,2.45,2.45,0,0,0,4.25-.53,2.61,2.61,0,0,0-.32-2.1A3.28,3.28,0,0,0,151.84,266.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.43,306.33a72.52,72.52,0,0,1-1.38-8.53,73.29,73.29,0,0,1-.87-8.6,73.69,73.69,0,0,1,1.39,8.53A69.65,69.65,0,0,1,144.43,306.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,289.67c0,.14-18.12.26-40.47.26s-40.47-.12-40.47-.26,18.12-.26,40.47-.26S224,289.52,224,289.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.91,305.23a50.17,50.17,0,0,1-.26-7.29,50.37,50.37,0,0,1,.26-7.3,52.14,52.14,0,0,1,.26,7.3A51.93,51.93,0,0,1,226.91,305.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.64,306.21c0,.15-18.37.26-41,.26s-41-.11-41-.26,18.36-.26,41-.26S227.64,306.07,227.64,306.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.74,297.19s.14-.19.53-.28a2,2,0,0,1,1.59.36,2.06,2.06,0,0,1,.75.9,1.92,1.92,0,0,1,.06,1.36,2.5,2.5,0,0,1-2.38,1.75,2.72,2.72,0,0,1-2.36-1.79,2.64,2.64,0,0,1,.31-2.4,2.9,2.9,0,0,1,1.22-1.06c.35-.15.57-.16.58-.13a4.24,4.24,0,0,0-1.49,1.38,2.34,2.34,0,0,0-.17,2,2.28,2.28,0,0,0,1.93,1.44,2,2,0,0,0,1.9-1.37,1.61,1.61,0,0,0-.57-1.83,2,2,0,0,0-1.34-.45C151,297.13,150.76,297.23,150.74,297.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.4,341.09a1.11,1.11,0,0,1-.31.08,6.6,6.6,0,0,1-.92.11,8.76,8.76,0,0,1-3.37-.51,10.44,10.44,0,0,1-4.23-2.76,9.07,9.07,0,0,1-1.07-11.57,10.53,10.53,0,0,1,3.66-3.49,8.65,8.65,0,0,1,3.22-1.11,4.78,4.78,0,0,1,.92-.06c.21,0,.32,0,.32,0a11.89,11.89,0,0,0-4.27,1.47,10.39,10.39,0,0,0-3.44,3.43,8.74,8.74,0,0,0,1,11,10.55,10.55,0,0,0,4,2.74A12,12,0,0,0,163.4,341.09Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.52,340.61c0,.15-11.35.27-25.35.27s-25.35-.12-25.35-.27,11.35-.26,25.35-.26S218.52,340.47,218.52,340.61Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.05,339.35a11.47,11.47,0,0,0,2.81-1.45,9.2,9.2,0,0,0,2.46-2.72,8.49,8.49,0,0,0,1.16-4.66,8.89,8.89,0,0,0-2.07-5.4,10.91,10.91,0,0,0-5.77-3.31,30.52,30.52,0,0,0-7.52-.69l-8.19.1-28.77.25-8.71,0-2.37,0a6.76,6.76,0,0,1-.83,0,5,5,0,0,1,.83-.07l2.37-.07,8.71-.19,28.76-.4,8.2-.09a31.22,31.22,0,0,1,7.64.73,11.3,11.3,0,0,1,6,3.51,9.25,9.25,0,0,1,2.11,5.65,8.79,8.79,0,0,1-1.28,4.83,9.43,9.43,0,0,1-2.59,2.74,8.45,8.45,0,0,1-2.13,1.08c-.26.09-.46.13-.59.17Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.71,332.38a2.77,2.77,0,0,1-.59.08l-1.71.13-6.29.38-20.77,1a18,18,0,0,1-6.85-.55c-1.05-.38-2-.89-3-1.21a4.25,4.25,0,0,0-2.83-.11c-1.75.65-3,2.27-4.77,2.68-1.74.6-3.7-1.05-3.11-2.58l.16.21a2.34,2.34,0,0,0-2,2.73l-.19,0c0-.69,0-1.24,0-1.68a2,2,0,0,1,.05-.58,3.8,3.8,0,0,1,0,.58c0,.44,0,1,.07,1.67l0,.89-.23-.86a2.36,2.36,0,0,1,.28-1.81,2.55,2.55,0,0,1,1.93-1.29l.26,0-.1.24a1.55,1.55,0,0,0,.61,1.7,2.25,2.25,0,0,0,2.1.38,6.74,6.74,0,0,0,2.24-1.21,10,10,0,0,1,2.48-1.52,4.74,4.74,0,0,1,3.13.08c1,.34,2,.84,3,1.2a17.77,17.77,0,0,0,6.65.51l20.78-.9,6.3-.21,1.71,0A2.28,2.28,0,0,1,215.71,332.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.41,349.09c0,.15-15.3.26-34.17.26s-34.17-.11-34.17-.26,15.29-.26,34.17-.26S222.41,349,222.41,349.09Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.12,134.78a9.38,9.38,0,0,1,.25,1.86c.11,1.18.24,2.86.38,4.86l0,.22-.23,0-5.34.63-3.74.4-.26,0v-.27c-.09-2.42-.15-4.51-.17-6a12.35,12.35,0,0,1,.06-2.36,12.43,12.43,0,0,1,.25,2.34c.11,1.48.23,3.57.35,6l-.27-.23,3.74-.43,5.34-.57-.2.24c-.1-2-.17-3.68-.2-4.86A9.32,9.32,0,0,1,147.12,134.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.48,130.11a47.21,47.21,0,0,1-4.19,3.51A48.87,48.87,0,0,1,134,137a20.79,20.79,0,0,1,4-3.8A20.93,20.93,0,0,1,142.48,130.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.56,136.8a27.21,27.21,0,0,1-4.2-3.14,27.19,27.19,0,0,1-3.88-3.55,26.2,26.2,0,0,1,4.21,3.15A26.39,26.39,0,0,1,150.56,136.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.81,
    y: 77.66,
    width: 19.11,
    height: 19.11,
    transform: "translate(8.86 -16.51) rotate(5.31)",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.72,91.27a8.47,8.47,0,0,1,0-2.07c0-.34,0-.69,0-1a1.65,1.65,0,0,1,.17-.65,1.41,1.41,0,0,1,.52-.51,12,12,0,0,0,1.14-.61,2.19,2.19,0,0,0,.75-1,1.93,1.93,0,0,0-.61-2.19,2.4,2.4,0,0,0-1.91-.58,3.58,3.58,0,0,0-1.76.84s.05-.22.31-.49a2.8,2.8,0,0,1,1.4-.72,2.77,2.77,0,0,1,2.27.58,2.54,2.54,0,0,1,.83,1.18,2.33,2.33,0,0,1,0,1.56,2.7,2.7,0,0,1-.94,1.23,11.12,11.12,0,0,1-1.2.6.9.9,0,0,0-.5.79l-.11,1A8.6,8.6,0,0,1,181.72,91.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.45,92.35c0,.07,0,.15,0,.22s0,0,.09,0,0,0,0,0,0,0,0,0-.06-.15-.06-.22.13-.17.33,0a.42.42,0,0,1,.16.41.51.51,0,0,1-.91.18.44.44,0,0,1,0-.44C181.26,92.24,181.44,92.28,181.45,92.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.4,
    y: 64.31,
    width: 18.32,
    height: 18.32,
    transform: "translate(-8.98 10.53) rotate(-7.53)",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.88,
    y: 88.34,
    width: 18.32,
    height: 18.32,
    transform: "matrix(1, 0.09, -0.09, 1, 9.44, -8.47)",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.48,
    y: 86.2,
    width: 18.32,
    height: 18.32,
    transform: "translate(9.38 -11.5) rotate(5.31)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.47,
    y: 62.88,
    width: 18.32,
    height: 18.32,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.23,
    y: 62.88,
    width: 18.32,
    height: 18.32,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.67,
    y: 63.19,
    width: 18.32,
    height: 18.32,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.53,100.68a15.64,15.64,0,0,1-4,.26,15.64,15.64,0,0,1-4-.26,15.11,15.11,0,0,1,4-.26A15.11,15.11,0,0,1,115.53,100.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.56,98.82c.09-.12,1.32.74,3.08,1.26l.45.13-.35.31-.13.11a12.17,12.17,0,0,1-2.82,2.17,11.93,11.93,0,0,1,2.48-2.55l.13-.12.09.44A5.46,5.46,0,0,1,112.56,98.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.6,140.71a11.71,11.71,0,0,1-1.75.09l-4.77.11c-1,0-2.09.14-3.3.13a11.51,11.51,0,0,1-3.79-.62,6.36,6.36,0,0,1-3.34-2.64,10.89,10.89,0,0,1-1.34-4.36c-.63-6.13-1.1-11.67-1.44-15.68-.16-1.95-.28-3.55-.38-4.76a11,11,0,0,1-.06-1.75A10.66,10.66,0,0,1,92.7,113c.13,1.21.31,2.8.53,4.74.42,4.09,1,9.58,1.6,15.65a10.33,10.33,0,0,0,1.26,4.16A5.86,5.86,0,0,0,99.16,140a11.21,11.21,0,0,0,3.63.64c1.16,0,2.27-.08,3.28-.07,2,0,3.65,0,4.78.05A11.89,11.89,0,0,1,112.6,140.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.8,143.32a9.08,9.08,0,0,1,2.65-2.72l.18-.14,0,.44a6.6,6.6,0,0,1-2.79-2.25c.1-.11,1.28.92,3,1.78l.38.19-.34.25-.17.14A31.24,31.24,0,0,1,110.8,143.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.66,
    y: 241.82,
    width: 17.65,
    height: 17.65,
    transform: "translate(23.57 -6.74) rotate(5.31)",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.88,
    y: 190.27,
    width: 17.65,
    height: 17.65,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.7,
    y: 165.31,
    width: 17.65,
    height: 17.65,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.7,
    y: 188.87,
    width: 17.65,
    height: 17.65,
    transform: "matrix(1, -0.07, 0.07, 1, -12.74, 6.01)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.7,
    y: 214.08,
    width: 17.65,
    height: 17.65,
    transform: "translate(21 -6.96) rotate(5.31)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.82,249.85s.71-.52,2-1.47a34.24,34.24,0,0,0,4.84-4.54,34.86,34.86,0,0,0,5.35-8.23A32.74,32.74,0,0,0,113,224,25.12,25.12,0,0,0,111,212.29a17.94,17.94,0,0,0-6.11-7.5,15.66,15.66,0,0,0-6-2.59c-1.55-.28-2.43-.24-2.42-.3a2.51,2.51,0,0,1,.63,0,10.44,10.44,0,0,1,1.82.13,15.36,15.36,0,0,1,6.21,2.48,18.08,18.08,0,0,1,6.33,7.61,25.24,25.24,0,0,1,2,12,32.35,32.35,0,0,1-3.07,11.76,34.14,34.14,0,0,1-5.5,8.26,31,31,0,0,1-5,4.46c-.63.48-1.17.77-1.52,1A2.56,2.56,0,0,1,97.82,249.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.59,251.25a37.88,37.88,0,0,1-6.3.62h0l-.31,0,0-.31a37.9,37.9,0,0,1,1-6.23,38.77,38.77,0,0,1-.52,6.29l-.27-.29h0A39,39,0,0,1,103.59,251.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.48,179.21c0,.14-10.2.26-22.77.26s-22.78-.12-22.78-.26,10.2-.26,22.78-.26S145.48,179.07,145.48,179.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.26,182.48a19.78,19.78,0,0,1,2.68-3.6l.12-.15.06.39a18.49,18.49,0,0,1-3.52-2.46,18.67,18.67,0,0,1,3.79,2l.26.16-.19.23-.12.14A19.07,19.07,0,0,1,143.26,182.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.87,299a87.94,87.94,0,0,1-9.49.26,88.06,88.06,0,0,1-9.5-.26,83.51,83.51,0,0,1,9.5-.27A83.4,83.4,0,0,1,249.87,299Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.7,303.75c-.07,0,0-.54.25-1.38a10.23,10.23,0,0,1,1.56-3.08l0,.28-.23-.44a43.13,43.13,0,0,0-2.91-4.35c.09-.13,2,1.45,3.37,4.1l.23.45.08.15-.1.13A28.19,28.19,0,0,0,248.7,303.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.62,
    y: 288.41,
    width: 25.96,
    height: 25.96,
    transform: "translate(-19.13 18.13) rotate(-3.75)",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273,301.66a3.9,3.9,0,1,0-6.05-.93h0l-.79.74.19,1.32-1.24-.35-1,.93.19,1.32-1.23-.35-.86.8.12.8-.75-.21-.5.47-.07,1.22,1.82.45,5.9-5.51A3.89,3.89,0,0,0,273,301.66Zm-.57-4.8a1.12,1.12,0,1,1-1.58-.06A1.12,1.12,0,0,1,272.4,296.86Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.4,296.86c0,.07-.37-.26-.91-.17a1,1,0,0,0-.69.53.89.89,0,0,0,1.12,1.21.93.93,0,0,0,.58-.65c.13-.54-.17-.88-.1-.92s.51.2.46,1a1.28,1.28,0,0,1-.75,1,1.35,1.35,0,0,1-1.74-1.87,1.29,1.29,0,0,1,1.08-.67C272.23,296.33,272.46,296.85,272.4,296.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273,301.66s-.06.09-.2.23a4.19,4.19,0,0,1-.75.52,4,4,0,0,1-3.37.1l.17,0L263,308.05l-.09.08-.13,0-1.82-.45-.2,0v-.2c0-.38.05-.8.07-1.22v-.1l.07-.07.5-.46.1-.1.14,0,.75.21-.32.28-.12-.8,0-.14.1-.09.85-.8.11-.09.14,0,1.23.35-.33.29c-.06-.42-.12-.87-.19-1.32l0-.14.1-.09.27-.25.73-.68.1-.1.14,0,1.24.35-.33.29c-.06-.45-.13-.89-.19-1.32l0-.14.1-.09.8-.74-.05.32a4.16,4.16,0,0,1-.18-3.71,4.11,4.11,0,0,1,5.59-2A4.12,4.12,0,0,1,274,297a4,4,0,0,1-.11,3.65,2.79,2.79,0,0,1-.88,1,8.75,8.75,0,0,0,.72-1.1,3.84,3.84,0,0,0,0-3.41,3.7,3.7,0,0,0-6.7.19,3.65,3.65,0,0,0,.18,3.26l.1.18-.15.14-.79.74.08-.23c.06.44.13.88.19,1.32l.06.4-.38-.11-1.24-.35.25-.06-.73.69-.26.24.08-.23c.06.46.13.9.19,1.32l0,.4-.38-.11-1.23-.35.24-.06-.85.8.08-.23c0,.28.08.56.11.81l.06.38-.38-.1-.75-.22.24-.05-.5.46.08-.17c0,.42-.05.84-.08,1.22l-.18-.25,1.81.47-.21.05,6-5.45.07-.07.1,0a3.88,3.88,0,0,0,3.17,0A9.43,9.43,0,0,0,273,301.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273,301.66a3.9,3.9,0,1,0-6.05-.93h0l-.79.74.19,1.32-1.24-.35-1,.93.19,1.32-1.23-.35-.86.8.12.8-.75-.21-.5.47-.07,1.22,1.82.45,5.9-5.51A3.89,3.89,0,0,0,273,301.66Zm-.57-4.8a1.12,1.12,0,1,1-1.58-.06A1.12,1.12,0,0,1,272.4,296.86Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.4,296.86c0,.07-.37-.26-.91-.17a1,1,0,0,0-.69.53.89.89,0,0,0,1.12,1.21.93.93,0,0,0,.58-.65c.13-.54-.17-.88-.1-.92s.51.2.46,1a1.28,1.28,0,0,1-.75,1,1.35,1.35,0,0,1-1.74-1.87,1.29,1.29,0,0,1,1.08-.67C272.23,296.33,272.46,296.85,272.4,296.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273,301.66s-.06.09-.2.23a4.19,4.19,0,0,1-.75.52,4,4,0,0,1-3.37.1l.17,0L263,308.05l-.09.08-.13,0-1.82-.45-.2,0v-.2c0-.38.05-.8.07-1.22v-.1l.07-.07.5-.46.1-.1.14,0,.75.21-.32.28-.12-.8,0-.14.1-.09.85-.8.11-.09.14,0,1.23.35-.33.29c-.06-.42-.12-.87-.19-1.32l0-.14.1-.09.27-.25.73-.68.1-.1.14,0,1.24.35-.33.29c-.06-.45-.13-.89-.19-1.32l0-.14.1-.09.8-.74-.05.32a4.16,4.16,0,0,1-.18-3.71,4.11,4.11,0,0,1,5.59-2A4.12,4.12,0,0,1,274,297a4,4,0,0,1-.11,3.65,2.79,2.79,0,0,1-.88,1,8.75,8.75,0,0,0,.72-1.1,3.84,3.84,0,0,0,0-3.41,3.7,3.7,0,0,0-6.7.19,3.65,3.65,0,0,0,.18,3.26l.1.18-.15.14-.79.74.08-.23c.06.44.13.88.19,1.32l.06.4-.38-.11-1.24-.35.25-.06-.73.69-.26.24.08-.23c.06.46.13.9.19,1.32l0,.4-.38-.11-1.23-.35.24-.06-.85.8.08-.23c0,.28.08.56.11.81l.06.38-.38-.1-.75-.22.24-.05-.5.46.08-.17c0,.42-.05.84-.08,1.22l-.18-.25,1.81.47-.21.05,6-5.45.07-.07.1,0a3.88,3.88,0,0,0,3.17,0A9.43,9.43,0,0,0,273,301.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.17,314.2a3,3,0,0,1,.07.64c0,.48.07,1.09.12,1.85.08,1.61.17,3.95.24,6.83s.1,6.31.08,10.13c0,1.9,0,3.9-.09,6a18.47,18.47,0,0,1-.24,3.19,4.53,4.53,0,0,1-1.68,2.91,6.81,6.81,0,0,1-3.15,1.12c-1.08.16-2.12.27-3.16.38-2.06.21-4.06.37-6,.47-3.81.2-7.25.2-10.13.11s-5.22-.28-6.82-.44c-.81-.07-1.43-.15-1.85-.21a2.6,2.6,0,0,1-.64-.11,3.22,3.22,0,0,1,.65,0l1.85.11c1.61.1,3.94.22,6.81.27s6.31,0,10.11-.22c1.89-.11,3.88-.28,5.94-.5,1-.11,2.08-.23,3.13-.38a6.59,6.59,0,0,0,2.92-1,4.07,4.07,0,0,0,1.49-2.6,19,19,0,0,0,.23-3.11q.06-3.11.12-6c.05-3.81.05-7.24,0-10.12s-.06-5.14-.08-6.82c0-.76,0-1.38,0-1.86A2.63,2.63,0,0,1,270.17,314.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.85,352.73a20.66,20.66,0,0,1-2.27-1.31,54.43,54.43,0,0,0-5.67-3l-.37-.16.3-.27.53-.47c2-1.79,3.87-3.39,5.22-4.53a16.06,16.06,0,0,1,2.26-1.77,14.65,14.65,0,0,1-2,2c-1.29,1.21-3.1,2.85-5.12,4.64l-.53.48-.07-.43a39.2,39.2,0,0,1,5.65,3.13A10.26,10.26,0,0,1,242.85,352.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.32,127.63a7.21,7.21,0,0,1,2.79,0,10.52,10.52,0,0,1,6.42,3.92,9.68,9.68,0,0,1,2,4.87,10.64,10.64,0,0,1-.11,3,11.79,11.79,0,0,1-5.55,7.89,11.46,11.46,0,0,1-7,1.4,13.06,13.06,0,0,1-6.64-2.75,12.14,12.14,0,0,1-3.86-5.46,11.7,11.7,0,0,1-.49-6,9.22,9.22,0,0,1,2.43-4.69,9.67,9.67,0,0,1,3.65-2.37,8.61,8.61,0,0,1,3.25-.55,7.49,7.49,0,0,1,2.05.33,3.45,3.45,0,0,1,.66.28,9.92,9.92,0,0,0-2.72-.41,8.82,8.82,0,0,0-3.13.62,9.6,9.6,0,0,0-3.5,2.35,8.86,8.86,0,0,0-2.26,4.52,11.34,11.34,0,0,0,.51,5.8,11.83,11.83,0,0,0,3.73,5.23,12.62,12.62,0,0,0,6.38,2.62,11,11,0,0,0,6.72-1.32,11.12,11.12,0,0,0,4.38-4.68,11.47,11.47,0,0,0,1-2.85,10.53,10.53,0,0,0,.13-2.84,9.41,9.41,0,0,0-1.89-4.7,10.54,10.54,0,0,0-6.16-3.94A15,15,0,0,0,223.32,127.63Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.11,114.39a3.72,3.72,0,0,1-.11,1.07,15.44,15.44,0,0,1-.82,2.82,17.55,17.55,0,0,1-14.79,11.11,14.81,14.81,0,0,1-2.93,0,3.92,3.92,0,0,1-1.06-.18c0-.1,1.53.12,3.95-.19a18.14,18.14,0,0,0,14.49-10.88C248.8,115.9,249,114.37,249.11,114.39Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,116.11a10.83,10.83,0,0,1-2-2.59l.4,0-.12.12a11.55,11.55,0,0,1-2.57,2.29,11.21,11.21,0,0,1,2.2-2.65l.12-.12.23-.24.17.28A10.62,10.62,0,0,1,251,116.11Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.67,
    y: 127.8,
    width: 16.43,
    height: 16.43,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.96,
    y: 110,
    width: 16.43,
    height: 16.43,
    transform: "translate(-13.17 36.29) rotate(-7.53)",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.4,
    y: 92.34,
    width: 16.43,
    height: 16.43,
    transform: "translate(-10.88 35.8) rotate(-7.53)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.67,
    y: 92.34,
    width: 16.43,
    height: 16.43,
    transform: "translate(16.45 -32.87) rotate(8.05)",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.39,102.2a17.61,17.61,0,0,1-4.23.37,17.26,17.26,0,0,1-4.25-.15,17.74,17.74,0,0,1,4.24-.37A17.1,17.1,0,0,1,258.39,102.2Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.25,129.71a4.64,4.64,0,0,1,.66.16,7,7,0,0,1,1.73.86,9.33,9.33,0,0,1,3.38,10.8,11.85,11.85,0,0,1-3.17,4.69,12.72,12.72,0,0,1-5.5,3,12.33,12.33,0,0,1-6.7-.16,9.51,9.51,0,0,1-5.28-4.09,11,11,0,0,1-1.58-6.05,10.77,10.77,0,0,1,1.6-5.42,11.23,11.23,0,0,1,3.49-3.48,12.89,12.89,0,0,1,6.75-2.05,10.32,10.32,0,0,1,1.93.13,2.73,2.73,0,0,1,.66.14c0,.06-.92-.14-2.58-.07a13,13,0,0,0-6.56,2.16,11,11,0,0,0-3.32,3.4,10.37,10.37,0,0,0-1.49,5.2,10.54,10.54,0,0,0,1.53,5.77,9,9,0,0,0,5,3.86,11.8,11.8,0,0,0,6.42.16,12.36,12.36,0,0,0,5.3-2.83,11.4,11.4,0,0,0,3.08-4.47,9,9,0,0,0,.45-4.7,9.11,9.11,0,0,0-3.54-5.79A10.55,10.55,0,0,0,145.25,129.71Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.15,104.7a2,2,0,0,1,.07.53c0,.34.07.85.06,1.5a28.43,28.43,0,0,1-.52,5.52,30.39,30.39,0,0,1-2.59,7.8,29.89,29.89,0,0,1-14,14,31.1,31.1,0,0,1-7.8,2.6,27.5,27.5,0,0,1-5.52.51,14.23,14.23,0,0,1-1.51-.06,2.41,2.41,0,0,1-.52-.06c0-.05.73,0,2-.08A31.9,31.9,0,0,0,174,127.9a31.63,31.63,0,0,0,8.42-15.72,33.3,33.3,0,0,0,.68-5.45A19.55,19.55,0,0,1,183.15,104.7Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.52,108.68a43.76,43.76,0,0,1-4.14-5.2l.43,0-.19.35a46.14,46.14,0,0,1-3.74,6,49.63,49.63,0,0,1,3.28-6.23l.2-.35.2-.34.24.32A45.22,45.22,0,0,1,187.52,108.68Z",
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-23"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 349.52,
    cy: 176.33,
    r: 29.74,
    transform: "translate(61.71 441.7) rotate(-69.45)",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.73,190.33l-19.87-4.64.57-2.44a10.2,10.2,0,0,1,12.25-7.62h0a10.21,10.21,0,0,1,7.62,12.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.72,171.85a6,6,0,1,1-4.48-7.2A6,6,0,0,1,356.72,171.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.3,203.62s-1.44-5.79-2.55-6.77-3.79-3.85-4.39-6.07c-.4-1.49-1.53-1.21-1.53-1.21l1,5.74-9.64-8.26a3.63,3.63,0,0,0,0,3.31c.91,1.84.54,1.62.54,1.62s-1.42.56-1,1.82a26.49,26.49,0,0,0,1.3,2.86,3.4,3.4,0,0,0-1.19,2.69,5.91,5.91,0,0,0-.66,2.8c0,1.7,2.43,5.34,2.43,5.34l13.63,9.62,7.36-9.41Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.6,192.54a18.91,18.91,0,0,0,2.73,2.66,20,20,0,0,0,3,2.39,38,38,0,0,0-5.71-5.05Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.68,191.33a23.87,23.87,0,0,0,2.26,3.47A23.24,23.24,0,0,0,326.5,198a43.4,43.4,0,0,0-4.82-6.71Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.69,196a6.69,6.69,0,0,0,1,2,7,7,0,0,0,1.31,1.85,6.69,6.69,0,0,0-1-2A6.78,6.78,0,0,0,321.69,196Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.89,199.08c-.1.06.15.61.46,1.29s.59,1.21.69,1.17,0-.65-.34-1.34S321,199,320.89,199.08Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.18,141.89a24.35,24.35,0,0,1,.75-3.6,3.52,3.52,0,0,1,.92-1.49c.45-.43,1-.15,1.41.46a11.24,11.24,0,0,1,0,9.27c-.38.61-1,.88-1.41.46a3.58,3.58,0,0,1-.92-1.49,24,24,0,0,1-.75-3.61,2.92,2.92,0,0,0-.08,1,10,10,0,0,0,.43,2.74,3.92,3.92,0,0,0,1,1.73,1.24,1.24,0,0,0,1.21.28,2,2,0,0,0,1-.82,11.16,11.16,0,0,0,0-9.87,2,2,0,0,0-1-.82,1.21,1.21,0,0,0-1.21.28,3.92,3.92,0,0,0-1,1.73,10,10,0,0,0-.43,2.74A2.79,2.79,0,0,0,381.18,141.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,187.69h0A11.21,11.21,0,0,1,394.92,177c-.25-6.1-.47-12.27-.47-12.27s-9.25-.83-9.95-10-.45-30.28-.45-30.28h0a31.87,31.87,0,0,1,32.23,2l-.48,32.21.05,17.32C415.81,181.77,412.81,187.23,407,187.69Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.24,149.22s0,.18.13.4a1.4,1.4,0,0,0,1,.51,2.53,2.53,0,0,0,2.37-2.54,2.67,2.67,0,0,0-.68-1.93,2.74,2.74,0,0,0-1.44-.82c-.94-.2-1.48.15-1.44.21s.56,0,1.32.23a2.3,2.3,0,0,1,1.58,2.28,2.12,2.12,0,0,1-1.71,2.1A1.76,1.76,0,0,1,395.24,149.22Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.16,141.46a34.49,34.49,0,0,0,6.16,1.31,33.58,33.58,0,0,0,6.25.72,33.47,33.47,0,0,0-6.16-1.31C384,141.62,381.19,141.29,381.16,141.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.24,143.65a8.4,8.4,0,0,0-5.94-8.18,5,5,0,0,0-3.26-7.78,8.63,8.63,0,0,0-1-.1,3.71,3.71,0,0,0-.51-.54c-2.85-2.54-3.13-6.46-6.41-8.42a10.15,10.15,0,0,0-10.51-.06c-2.16-1.08-4.17-2.48-6.33-3.57-3-1.51-6.61-2.41-9.58-.9-2.13,1.08-3.56,3.21-5.63,4.4-3,1.69-7,1.32-8.41,5.68a7.4,7.4,0,0,0,.06,4.65c2,5.92,9.37,8.28,14.64,5.71.11,1-.87,3.23.19,6.4.34,1,.47,2.55,2,2.58,1.57-2,4.14-2.75,6.25-1.39a5.33,5.33,0,0,1,1.79,6.65,7,7,0,0,1-4.48,3.41,3.5,3.5,0,0,0-2.74,3.79c.27,2.3,4.09,3.15,5.82,5,2.69,2.95,8.58,4.19,12.55,4.64,3.37.39,3.48.47,4.9-1.59a9.52,9.52,0,0,0,3.13-.48,10.8,10.8,0,0,0,6.79-12.31A8.37,8.37,0,0,0,434.24,143.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.45,147.2a5.56,5.56,0,0,1-1.24.27,7,7,0,0,1-3.42-.48,6.76,6.76,0,0,1-3.7-3.47,7.26,7.26,0,0,1,.06-6.16l.09-.18.1.16a16.87,16.87,0,0,1-6.21-.41,7.81,7.81,0,0,1-4.18-2.79,5.86,5.86,0,0,1-1.24-3.16,3.7,3.7,0,0,1,.09-1.25,8.47,8.47,0,0,0,0,1.24,6,6,0,0,0,1.27,3.08,7.75,7.75,0,0,0,4.12,2.7,17.14,17.14,0,0,0,6.14.38l.18,0-.08.17-.08.17a7.06,7.06,0,0,0-.07,6,6.67,6.67,0,0,0,3.57,3.42,7.26,7.26,0,0,0,3.36.53C415,147.32,415.44,147.17,415.45,147.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.29,139.57a12.71,12.71,0,0,0,.82-1,7.36,7.36,0,0,0,1.21-3.31,6.85,6.85,0,0,0-1.3-4.95,7.21,7.21,0,0,0-5.59-2.7,6.73,6.73,0,0,0-2.58.48l-.12.06,0-.14a6.8,6.8,0,0,0-2.73-4.57,6.53,6.53,0,0,0-4.13-1.24,7.07,7.07,0,0,0-2.83.73c-.61.31-.91.55-.92.53a5,5,0,0,1,.89-.6,6.77,6.77,0,0,1,2.85-.79,6.57,6.57,0,0,1,4.25,1.22,7,7,0,0,1,2.82,4.7l-.14-.09a6.92,6.92,0,0,1,2.66-.5,7.36,7.36,0,0,1,5.74,2.79,7,7,0,0,1,1.3,5.09,7.26,7.26,0,0,1-1.29,3.33A4.89,4.89,0,0,1,423.29,139.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.34,154a2.5,2.5,0,0,1-.37.26,3.31,3.31,0,0,1-1.19.38,3.83,3.83,0,0,1-1.89-.23,3.51,3.51,0,0,1-1.84-1.55l.15,0a6.19,6.19,0,0,1-5.32,1.37,6.05,6.05,0,0,1-3.65-2.43,3.44,3.44,0,0,1-.33-.57,7.17,7.17,0,0,0,1.66,1.75,6.13,6.13,0,0,0,2.36,1.06,6,6,0,0,0,3.15-.2,6.09,6.09,0,0,0,2-1.13l.09-.08.06.11a3.41,3.41,0,0,0,1.73,1.48,3.85,3.85,0,0,0,1.82.27A4.2,4.2,0,0,0,414.34,154Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.29,143a5.55,5.55,0,0,0-4-3.1c-1.72-.32-4.83,1.47-4.83,1.47a2,2,0,0,0-1.21-.92,4.16,4.16,0,0,0-3.73,6.93,4.19,4.19,0,1,0,5.88,5.45,4.4,4.4,0,0,0,7-5.21A3.86,3.86,0,0,0,429.29,143Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.11,146.13a9.2,9.2,0,0,0-2-1.9,5.12,5.12,0,0,0-1.76-.74c-.49-.09-.8-.06-.8-.1a1.72,1.72,0,0,1,.82,0,4.39,4.39,0,0,1,1.86.71,5.76,5.76,0,0,1,1.44,1.35A2.4,2.4,0,0,1,419.11,146.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,140.47a2.23,2.23,0,0,1,.55.61,7,7,0,0,1,.9,1.78,4.36,4.36,0,0,1,.15,2.79,7.89,7.89,0,0,0-.34-2.72A13.45,13.45,0,0,0,419,140.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.1,140.15a2.82,2.82,0,0,1,.28,2.19,3,3,0,0,1-1.2,1.87,5.62,5.62,0,0,0,1-1.91A5.06,5.06,0,0,0,423.1,140.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.57,140.25a3.38,3.38,0,0,1-.21,2.48,3.07,3.07,0,0,1-1.22,1.31,1.47,1.47,0,0,1-.7.24,3.8,3.8,0,0,0,1.73-1.64,5.28,5.28,0,0,0,.39-1.67C426.59,140.53,426.54,140.26,426.57,140.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.11,148.75a2.79,2.79,0,0,1,1.89-.58,3.68,3.68,0,0,1,1.95.35,14,14,0,0,0-1.95-.14A6.31,6.31,0,0,0,414.11,148.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.11,153.18a1.5,1.5,0,0,1,.19-.67,3.46,3.46,0,0,1,1-1.37,2.7,2.7,0,0,1,2.31-.42,4.26,4.26,0,0,0-2.19.59,3.78,3.78,0,0,0-1,1.26A4.85,4.85,0,0,1,414.11,153.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.68,151a6.3,6.3,0,0,0,1-.21,4.24,4.24,0,0,0,2.22-1.75,4.52,4.52,0,0,0,.51-4.07,6.43,6.43,0,0,0-3.5-3.68,9.51,9.51,0,0,0-5.16-.54,16.3,16.3,0,0,0-4.12,1.26c-1.13.49-2,.95-2.63,1.27l-.71.35-.25.12s.07-.06.23-.15l.69-.4c.61-.33,1.48-.81,2.61-1.33a16.63,16.63,0,0,1,4.15-1.31,9.45,9.45,0,0,1,5.27.54,6.55,6.55,0,0,1,3.6,3.81,4.83,4.83,0,0,1,.21,2.33,4.7,4.7,0,0,1-.78,1.88,4.29,4.29,0,0,1-2.32,1.75A2.75,2.75,0,0,1,438.68,151Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.15,151.17c2.9-.59,4.24-4.47,2.88-7.09s-4.6-3.86-7.54-3.63-5.66,1.66-8.16,3.24a4.57,4.57,0,0,0-5.79,2.2,4.59,4.59,0,0,0-1.74,9,7.67,7.67,0,1,0,11.89,8.92,7.62,7.62,0,0,0,8.46-12.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.91,157.05a2.18,2.18,0,0,1,0,1.06,3.48,3.48,0,0,1-1.88,2.2,6.86,6.86,0,0,1-4.47.54,7.56,7.56,0,0,1-4.78-3.16l.18-.05a4.72,4.72,0,0,1-2.48,3.84,5.2,5.2,0,0,1-4.95,0,6.68,6.68,0,0,1-3-3,4.8,4.8,0,0,1-.45-2,2.8,2.8,0,0,1,.73-1.86l.09.16a4.55,4.55,0,0,1-4.26-7.58,4.67,4.67,0,0,1,2.92-1.37,3,3,0,0,1,1.16.07,6,6,0,0,0-1.16,0,4.64,4.64,0,0,0-2.83,1.39,4.4,4.4,0,0,0,4.13,7.31l.31-.06-.22.23a3.31,3.31,0,0,0-.23,3.66,6.46,6.46,0,0,0,2.93,2.94,5,5,0,0,0,4.76,0,4.55,4.55,0,0,0,2.39-3.67v-.3l.16.25a7.46,7.46,0,0,0,4.66,3.11,6.83,6.83,0,0,0,4.38-.49,3.49,3.49,0,0,0,1.87-2.12A3.27,3.27,0,0,0,441.91,157.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.06,150.07a2.39,2.39,0,0,0,.43-1,2.94,2.94,0,0,0-1.07-2.65,6.52,6.52,0,0,0-9.92,1.76l-.17.32,0-.36a4.94,4.94,0,0,0-2.47-3.95,4.53,4.53,0,0,0-3.78-.32,5,5,0,0,0-2.16,1.44c-.41.47-.56.78-.58.77a3.21,3.21,0,0,1,.52-.82,5,5,0,0,1,2.17-1.52,4.65,4.65,0,0,1,3.92.29,5.06,5.06,0,0,1,2.58,4.1l-.19-.05a7,7,0,0,1,1-1.35,6.62,6.62,0,0,1,9.21-.42,3,3,0,0,1,1.05,2.78,2,2,0,0,1-.32.77A1,1,0,0,1,440.06,150.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440,159.21a4,4,0,0,1-.11.87,5.83,5.83,0,0,1-1,2.22,5.73,5.73,0,0,1-3.07,2.14,6,6,0,0,1-4.74-.69l.13,0a8.81,8.81,0,0,1-7.55,4.7,8.68,8.68,0,0,1-7.11-3.69,7.44,7.44,0,0,1-1.21-6.46,4.62,4.62,0,0,1,3.13-3.09,3.4,3.4,0,0,1,1.23-.11,1.78,1.78,0,0,1,.43.07,4,4,0,0,0-1.63.12,4.52,4.52,0,0,0-3,3.06,7.29,7.29,0,0,0,1.23,6.29,8.49,8.49,0,0,0,7,3.6,8.63,8.63,0,0,0,7.39-4.57l0-.1.09.06a5.87,5.87,0,0,0,4.6.7,5.65,5.65,0,0,0,3-2.06,6.08,6.08,0,0,0,1.05-2.17C439.92,159.51,439.93,159.21,440,159.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.33,152.38a2.57,2.57,0,0,1-.42.58,4.46,4.46,0,0,1-1.61,1.11,4.31,4.31,0,0,1-2.89.13,4.58,4.58,0,0,1-2.72-2.28l.14.05-.44.16a5.1,5.1,0,0,1-3.71-.3,4.8,4.8,0,0,1-2.14-2.17,5,5,0,0,1-.51-2,3.09,3.09,0,0,1,.06-.76,5.6,5.6,0,0,0,.58,2.69,4.75,4.75,0,0,0,2.1,2.06,4.88,4.88,0,0,0,3.55.27c.15,0,.29-.1.43-.15l.09,0,0,.09a4.42,4.42,0,0,0,2.59,2.19,4.14,4.14,0,0,0,2.78-.09A4.82,4.82,0,0,0,434.33,152.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "445.26 408.28 448.16 462.01 428.7 466.71 424.82 414.23 445.26 408.28",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "448.74 461.55 452.05 476.13 429.66 476.13 428.7 466.64 448.74 461.55",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.2,474a15.9,15.9,0,0,0,3.26.19c2,0,4.81,0,7.88-.15l7.85-.33a18.81,18.81,0,0,0,3.26-.26,15.61,15.61,0,0,0-3.27-.18c-2,0-4.8,0-7.87.15l-7.85.33A18.33,18.33,0,0,0,429.2,474Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.69,464.39c-.17,0-.17,2.13,0,4.72s.45,4.69.62,4.68.17-2.12,0-4.72S438.86,464.38,438.69,464.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "452.05 476.13 429.66 476.13 429.45 474.01 451.65 473.46 452.05 475.88",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "371.37 434.4 366.65 470 349.42 468.8 353.04 436.17 371.37 434.4",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.24,464.94h0s-19.35,6.54-19.67,10.07l37,1.07.33-9.67-1.37.27A27.54,27.54,0,0,1,349.24,464.94Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.58,468.1a1.5,1.5,0,0,1,1,1.75,1.44,1.44,0,0,1-1.73,1,1.59,1.59,0,0,1-1-1.86,1.51,1.51,0,0,1,1.91-.84",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366.58,476.09l0-3-35.47.09s-1.67.67-1.52,1.84Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M348.65,464.73c0,.18.9.29,1.77.9s1.33,1.38,1.49,1.31-.07-1.12-1.13-1.83S348.61,464.56,348.65,464.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.72,466.22c-.05.18.73.51,1.32,1.29s.74,1.6.92,1.59.33-1-.42-2S344.73,466.05,344.72,466.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.38,470.81c.16,0,.44-.86,0-1.86s-1.27-1.42-1.35-1.27.42.69.77,1.52S342.2,470.78,342.38,470.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.05,464.64a3.51,3.51,0,0,0,1.86,0,7.81,7.81,0,0,0,1.95-.54,7.69,7.69,0,0,0,1.08-.53,2.21,2.21,0,0,0,.58-.42.8.8,0,0,0,.11-1,1,1,0,0,0-.78-.43,2.48,2.48,0,0,0-.7.07,7.87,7.87,0,0,0-1.16.36,6.31,6.31,0,0,0-1.75,1.08c-.88.77-1.19,1.43-1.13,1.47s.52-.49,1.41-1.12a7.11,7.11,0,0,1,1.68-.89,6.69,6.69,0,0,1,1.07-.29c.4-.1.73-.09.83.09s0,.09-.05.2a1.63,1.63,0,0,1-.42.31,8.06,8.06,0,0,1-1,.53,11.06,11.06,0,0,1-1.81.64A11.87,11.87,0,0,0,349.05,464.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.28,464.9a2.94,2.94,0,0,0,.54-1.77,6,6,0,0,0-.19-2,6.2,6.2,0,0,0-.44-1.14,1.55,1.55,0,0,0-1.16-1,.87.87,0,0,0-.78.5,2.44,2.44,0,0,0-.21.67,3.78,3.78,0,0,0,0,1.25,4.22,4.22,0,0,0,.73,1.94c.7,1,1.45,1.22,1.46,1.15s-.55-.45-1.08-1.39a4.4,4.4,0,0,1-.54-1.76,3.91,3.91,0,0,1,.07-1.07c.07-.39.23-.7.37-.66s.49.31.63.63a6.42,6.42,0,0,1,.74,2.88C349.4,464.2,349.18,464.87,349.28,464.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.87,254.21s13.66,22.82,13.66,36.47l3.37,166.26-21.59,5.14L409.84,299.61S370,462.5,368.69,462.5,347.77,459,347.77,459l29.78-204Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.37,295.14a1.91,1.91,0,0,0,0,.42c0,.31.1.71.18,1.22.17,1.11.42,2.68.74,4.69.67,4.07,1.6,10,2.69,17.24,2.2,14.54,4.94,34.72,7.24,57.12s3.69,42.69,4.49,57.4c.4,7.36.69,13.31.86,17.43.09,2,.17,3.62.22,4.74,0,.52.05.93.07,1.23a2,2,0,0,0,.05.42,2.66,2.66,0,0,0,0-.42c0-.31,0-.72,0-1.23,0-1.12-.06-2.72-.11-4.75-.1-4.12-.32-10.08-.67-17.44-.69-14.73-2-35.06-4.32-57.44s-5.1-42.56-7.41-57.12c-1.15-7.28-2.14-13.16-2.88-17.22-.36-2-.65-3.57-.85-4.67l-.24-1.21A2.94,2.94,0,0,0,422.37,295.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.21,297.89c-.17,0-6.75,36.46-14.71,81.49S359.22,461,359.38,461s6.74-36.45,14.71-81.5S388.37,297.92,388.21,297.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.61,299.33a2,2,0,0,0,.23-.42c.13-.28.32-.69.55-1.23A44.49,44.49,0,0,0,413,293a47.81,47.81,0,0,0,1.54-16.23c-.11-1.6-.32-3.14-.57-4.63a43,43,0,0,0-1-4.23c-.76-2.66-1.55-5-2.23-7s-1.27-3.56-1.69-4.65l-.5-1.25a1.61,1.61,0,0,0-.21-.42,2.61,2.61,0,0,0,.11.46c.12.35.25.77.41,1.28.39,1.19.9,2.78,1.53,4.7s1.39,4.35,2.11,7c.37,1.32.73,2.72,1,4.18s.45,3,.56,4.59a50.08,50.08,0,0,1-1.38,16.1c-.5,2-1.06,3.61-1.43,4.71A12.37,12.37,0,0,0,410.61,299.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.5,271.4a2,2,0,0,0,0,.32c0,.24,0,.53,0,.88,0,.82-.09,1.92-.14,3.28-.1,2.86-.24,6.82-.41,11.57l.14-.2-8.31,3.38.23,0-6.75-4.11-.44-.26.13.2c-.51-5.49-1-10.65-1.4-15.1l-.23.25,12.42-.12,3.54-.06.95,0,.35,0a10.41,10.41,0,0,0-1.2,0l-3.49-.06-12.57-.12H387l0,.25c.4,4.46.85,9.61,1.34,15.1v.14l.11.06.44.27,6.76,4.09.11.07.11,0,8.29-3.44.14-.05v-.15c.07-4.81.13-8.83.18-11.72,0-1.34,0-2.43,0-3.23S404.51,271.39,404.5,271.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.74,267s0,.41.14,1.12.28,1.78.47,3l1.73,10.69.09-.22-6.28,4.66.22,0-7.63-2.13-.39-.1.18.17-4-13.67-.17.28,11.27-2.68,3.21-.8c.75-.19,1.16-.3,1.17-.32a8.86,8.86,0,0,0-1.1.2l-3.18.66L420,270.37l-.24.05.07.23c1.16,4,2.51,8.72,3.95,13.7l0,.14.14,0,.39.11,7.63,2.1.12,0,.1-.08,6.24-4.7.12-.08,0-.13c-.81-4.43-1.49-8.13-2-10.8-.24-1.23-.43-2.22-.58-3A8.26,8.26,0,0,0,435.74,267Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.14,296.1a86.72,86.72,0,0,0,9.19,2.26,85.27,85.27,0,0,0,9.29,1.75,86.9,86.9,0,0,0-9.18-2.26A85.66,85.66,0,0,0,392.14,296.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,296.82a8.09,8.09,0,0,0,2.35,0,38.81,38.81,0,0,0,5.62-.88,37.43,37.43,0,0,0,5.43-1.66,8.32,8.32,0,0,0,2.12-1,14.64,14.64,0,0,0-2.24.68c-1.37.45-3.28,1-5.43,1.5s-4.11.82-5.54,1A13.41,13.41,0,0,0,419,296.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "392.2 173.25 394.58 168.36 415.26 167.58 418.5 173.94 392.54 173.94",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.38 205.27 331.17 215.12 357.32 238.51 364.97 220.47 341.38 205.27",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.16 235 423.26 227.1 427.7 210.61 443.92 216.13 443.16 235",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.83,239.45c-5-2.46-6.23-8.38-3.81-13.36L375.64,182a8.1,8.1,0,0,1,2.08-2.84,23.29,23.29,0,0,1,17-5.84l21.51-.57s16.89,0,23.23,13.32c.47,1,10.29,20.45,16.76,33.28a11.11,11.11,0,0,1-6.09,15.43h0a11.11,11.11,0,0,1-14-5.88l-7-15.68-4.43,22.46,6.38,18.51-53.33.73,4.11-24.76,1.29-17.66-10.81,22.3a10.09,10.09,0,0,1-13.57,4.63Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M423,235.27c-4,3-10,2-14.95,1.19a21.61,21.61,0,0,1-13-7.06,8.72,8.72,0,0,1-2.42-6.16c.2-2.25,2.19-4.43,4.44-4.16,2.58.31,3.82,3.2,5.06,5.48a20,20,0,0,0,20.82,9.77S423.68,234.73,423,235.27Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M390,200.57c-1.26,10.14-.7,9.37-2.81,19.37-1,4.92-2.31,10.05-5.7,13.76l1.68-21.18Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "431.14 254.21 432.67 249.76 428.69 247.11 379.78 243.08 376.33 249.56 377.81 254.94 431.14 254.21",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.32,215.39a13,13,0,0,0,1.09,2.5c.74,1.51,1.82,3.57,3.13,5.78s2.6,4.16,3.57,5.54a13.35,13.35,0,0,0,1.67,2.15,15.82,15.82,0,0,0-1.37-2.36c-.88-1.42-2.11-3.39-3.42-5.59s-2.43-4.23-3.26-5.69A13.91,13.91,0,0,0,429.32,215.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434,223.85a6.6,6.6,0,0,0,.34,3.68,6.48,6.48,0,0,0,1.87,3.2c.13-.08-.77-1.46-1.37-3.35S434.17,223.84,434,223.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.3,179.49c0,.08.89.41,2.22,1.24a14.12,14.12,0,0,1,4.33,4.2,14.33,14.33,0,0,1,2.14,5.65c.23,1.54.16,2.53.25,2.53a6.54,6.54,0,0,0,.11-2.58,12.89,12.89,0,0,0-6.64-10.12A6.66,6.66,0,0,0,381.3,179.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.83,235.92c.14,0,2.53-10.19,5.35-22.82s5-22.9,4.85-22.93-2.54,10.18-5.36,22.82S424.68,235.89,424.83,235.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354,222.73a17.39,17.39,0,0,0,2.35-2.21,17,17,0,0,0,2.29-2.3,7.48,7.48,0,0,0-2.65,1.92A7.2,7.2,0,0,0,354,222.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372,235.64a9,9,0,0,0,.82-1.35c.5-.88,1.19-2.18,2-3.79,1.68-3.22,3.93-7.7,6.38-12.67s4.71-9.44,6.38-12.67l2-3.81a8.78,8.78,0,0,0,.68-1.43,8.08,8.08,0,0,0-.86,1.33c-.52.87-1.25,2.15-2.12,3.74-1.76,3.18-4.07,7.64-6.52,12.61l-6.25,12.73c-.77,1.57-1.41,2.87-1.89,3.87A10,10,0,0,0,372,235.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.17,222s0,.12,0,.35a6.87,6.87,0,0,0,.16,1,13,13,0,0,0,1.33,3.45,19.53,19.53,0,0,0,9,8,39.13,39.13,0,0,0,11.76,2.93c1.54.18,2.79.28,3.65.33a7.29,7.29,0,0,0,1.35,0,6.37,6.37,0,0,0-1.33-.24l-3.63-.49a43,43,0,0,1-11.58-3,20,20,0,0,1-8.9-7.69A19,19,0,0,1,391.17,222Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.9,247.87c0,.14,6.6.73,14.77,1.3s14.8.92,14.81.77-6.6-.72-14.77-1.29S401.91,247.73,401.9,247.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.37,243.9A24,24,0,0,0,392.3,254c.15,0,.22-2.28.51-5.06S393.51,243.94,393.37,243.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.94,240.71a6.38,6.38,0,0,0-.45,2,25.16,25.16,0,0,0-.13,5,24.46,24.46,0,0,0,.83,4.92,6.42,6.42,0,0,0,.72,1.94c.16,0-.78-3.05-1-6.89S390.1,240.74,389.94,240.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.15,173.6a105.7,105.7,0,0,0,10.67-.33c5.88-.34,10.64-.72,10.63-.86a105.53,105.53,0,0,0-10.66.33C396.9,173.07,392.14,173.46,392.15,173.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.4,173.26a5.79,5.79,0,0,1-.7.11l-2,.3-3.14.56a13.83,13.83,0,0,0-4,1.22,20.42,20.42,0,0,0-4.23,2.77,16.76,16.76,0,0,0-3.62,4.49c-1.83,3.68-3.71,7.85-5.77,12.16L359.48,217c-1.33,2.78-2.43,5-3.21,6.68-.38.75-.67,1.35-.9,1.81a2.85,2.85,0,0,1-.35.61,3.59,3.59,0,0,1,.25-.66c.21-.47.48-1.08.81-1.84l3.07-6.76c2.61-5.7,6.27-13.54,10.35-22.18,2.06-4.32,3.94-8.45,5.82-12.17a17,17,0,0,1,3.76-4.59,20.32,20.32,0,0,1,4.35-2.78,14,14,0,0,1,4.09-1.17c1.23-.2,2.29-.35,3.16-.47s1.55-.18,2-.21A2.58,2.58,0,0,1,393.4,173.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.69,226.74l-.22,0-.62-.09c-.55-.08-1.33-.2-2.29-.38a31.73,31.73,0,0,1-7.34-2.17,15.46,15.46,0,0,1-6-4.7,9,9,0,0,1-1.47-2.81s.13.28.37.77a11.7,11.7,0,0,0,1.22,1.95,15.8,15.8,0,0,0,6,4.6,34.11,34.11,0,0,0,7.28,2.21l2.27.45.62.13A.64.64,0,0,1,377.69,226.74Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.71,214.92a2.63,2.63,0,0,1-.58.18c-.37.09-.9.25-1.55.48a17.44,17.44,0,0,0-8.39,6.4,15,15,0,0,0-.88,1.37,2.57,2.57,0,0,1-.32.51,4.06,4.06,0,0,1,.25-.55,10.12,10.12,0,0,1,.83-1.41,16.21,16.21,0,0,1,3.69-3.94,16.45,16.45,0,0,1,4.77-2.52,10.57,10.57,0,0,1,1.58-.42A3.8,3.8,0,0,1,354.71,214.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.4,202h-.2l-.56-.05c-.49,0-1.2-.13-2.07-.27a33.15,33.15,0,0,1-12.72-5.05c-.73-.49-1.31-.91-1.69-1.22l-.45-.35a1.47,1.47,0,0,1-.14-.14l.17.1.46.33c.4.29,1,.69,1.73,1.16a37.21,37.21,0,0,0,6.09,3.12,36.81,36.81,0,0,0,6.57,1.9c.87.16,1.57.28,2.06.34l.56.08A.5.5,0,0,1,388.4,202Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.7,179.58s-.66-.12-1.87-.18a23.41,23.41,0,0,0-5.11.34c-2.14.34-4.64,1-7.45,1.57a36.54,36.54,0,0,1-9.31.74c-3.31-.13-6.45-.52-9.31-.79a62.53,62.53,0,0,0-7.6-.36,31.48,31.48,0,0,0-5.09.54l-1.36.32-.48.1s.16-.06.47-.14l1.35-.36a28.5,28.5,0,0,1,5.11-.6,60,60,0,0,1,7.62.31c2.86.26,6,.64,9.3.77a36.66,36.66,0,0,0,9.26-.72c2.8-.57,5.32-1.21,7.47-1.52a22.3,22.3,0,0,1,5.13-.28,11.34,11.34,0,0,1,1.39.17C433.54,179.54,433.7,179.58,433.7,179.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.29,205.31l-.43,0-1.27.1-4.64.32c-3.92.25-9.33.69-15.33.81a79,79,0,0,1-15.31-1,42.72,42.72,0,0,1-6.17-1.54l.43.1,1.22.32c1.06.28,2.61.63,4.54,1a82.67,82.67,0,0,0,15.29.94c6-.13,11.4-.55,15.32-.75l4.65-.26,1.26-.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.13,207.75s0,.06-.13.17l-.42.46c-.36.4-.92,1-1.64,1.6a30.92,30.92,0,0,1-13.23,7c-.93.23-1.7.38-2.24.46l-.61.08a.73.73,0,0,1-.22,0,.64.64,0,0,1,.21-.06l.61-.12c.53-.1,1.29-.28,2.22-.52a33.21,33.21,0,0,0,13.16-7c.73-.63,1.3-1.16,1.68-1.55l.45-.43Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.31,192.25a1.61,1.61,0,0,1-.24.27,8.78,8.78,0,0,1-.74.64,13.48,13.48,0,0,1-2.74,1.71,13,13,0,0,1-3.08,1,9.47,9.47,0,0,1-1,.15c-.23,0-.36,0-.36,0s.5-.11,1.3-.3a16.27,16.27,0,0,0,3-1.06,16.6,16.6,0,0,0,2.74-1.63C440.91,192.56,441.29,192.22,441.31,192.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.2,223.91a15,15,0,0,1-2,2.33,19.82,19.82,0,0,1-2.6,2.11,19.61,19.61,0,0,1-7.55,3.07,19.36,19.36,0,0,1-3.33.32,14.86,14.86,0,0,1-3.06-.27h.22l.6.05a17.73,17.73,0,0,0,2.24.07,20.46,20.46,0,0,0,13.38-5.46,19.15,19.15,0,0,0,1.55-1.61l.4-.46C457.14,224,457.19,223.9,457.2,223.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.89,169.64a.93.93,0,0,1-.24,0l-.7,0-2.54-.11c-2.14-.07-5.11-.07-8.38.13s-6.22.57-8.34.9l-2.51.42-.68.12a.93.93,0,0,1-.25,0l.24-.07.67-.15c.59-.13,1.44-.3,2.5-.48a77.07,77.07,0,0,1,8.35-1,80.37,80.37,0,0,1,8.41-.07c1.07.06,1.94.12,2.54.17l.69.07Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.28,226.49s-.13,0-.38,0-.59-.07-1-.15a15.24,15.24,0,0,1-3.25-1,15.73,15.73,0,0,1-3-1.63,9.12,9.12,0,0,1-.82-.63c-.18-.16-.28-.25-.27-.26s.44.3,1.17.76a19.27,19.27,0,0,0,3,1.57,19.54,19.54,0,0,0,3.2,1C390.76,226.38,391.29,226.46,391.28,226.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.71,230.44l-.29.05-.86.1c-.74.09-1.82.2-3.16.31-2.66.24-6.36.47-10.44.57s-7.79,0-10.47-.09c-1.34,0-2.42-.11-3.17-.16l-.86-.06-.3,0h.31l.86,0,3.16.1c2.68.07,6.38.11,10.46,0s7.77-.31,10.44-.51l3.16-.24.86-.06A1,1,0,0,1,425.71,230.44Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.15,249.61a1.8,1.8,0,0,1-.49.13l-1.38.23a32.15,32.15,0,0,1-9.19-.06c-.58-.09-1-.18-1.37-.25a2.73,2.73,0,0,1-.5-.13,2.39,2.39,0,0,1,.51.05l1.38.18a38.46,38.46,0,0,0,4.58.3,40,40,0,0,0,4.57-.24l1.38-.16A2.43,2.43,0,0,1,389.15,249.61Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.4,247.59a5.29,5.29,0,0,0-1.36-.83,4.91,4.91,0,0,0-1.58-.18,2.05,2.05,0,0,1,1.65,0A2.1,2.1,0,0,1,392.4,247.59Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.58,250l-.32.07-.92.18c-.81.16-2,.36-3.43.57a112,112,0,0,1-22.85,1c-1.46-.08-2.65-.17-3.46-.26l-.94-.09a2.47,2.47,0,0,1-.33-.05,1.21,1.21,0,0,1,.33,0l.95,0c.81.06,2,.13,3.46.2,2.92.13,7,.2,11.43,0s8.49-.64,11.39-1c1.45-.2,2.62-.38,3.43-.51l.94-.14A1.29,1.29,0,0,1,424.58,250Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122,411.26c.89-3.07,2.79-6,5.72-7.31s6.6-.56,9.72.57,6.2,2.66,9.52,2.86,7.07-1.37,8.06-4.54c.94-3-.86-6.17-3.11-8.34a19.68,19.68,0,0,0-32.24,7.74",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122,411.26c.89-3.07,2.79-6,5.72-7.31s6.6-.56,9.72.57,6.2,2.66,9.52,2.86,7.07-1.37,8.06-4.54c.94-3-.86-6.17-3.11-8.34a19.68,19.68,0,0,0-32.24,7.74"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M95.72,424.6c-4.88-4.63-4.63-12.68-2.2-19s7.73-11.07,13.65-14.24a43.24,43.24,0,0,1,37.7-1.22,17.88,17.88,0,0,0-14.46,8.49c-2.67,4.43-3.27,9.82-5.47,14.5A22.82,22.82,0,0,1,95.72,424.6",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.37,396.8c-5.39-6.37-6.11-16.59-5.31-24.89s2.72-16.67,1.41-24.91c-.78-4.88-2.67-9.54-3.31-14.45s.26-10.44,4.06-13.6c4.37-3.64,11.24-2.78,15.78.63s7.17,8.78,9.1,14.13c4.22,11.74,5.77,24.77,2.3,36.76s-11.61,22.71-23.56,26.33",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.78,449a5.83,5.83,0,0,1,0-.73c0-.48,0-1.19,0-2.1.07-1.83.25-4.47.66-7.71a102.61,102.61,0,0,1,2.07-11.3,52.28,52.28,0,0,1,5.15-13.07,54.93,54.93,0,0,1,8.42-11.26,54.29,54.29,0,0,1,8.83-7.34c1.35-.93,2.65-1.64,3.77-2.29s2.16-1.1,3-1.5l1.94-.81a4.31,4.31,0,0,1,.69-.26,6.22,6.22,0,0,1-.65.34l-1.91.89c-.8.42-1.79.94-2.93,1.56s-2.38,1.39-3.71,2.34a54.2,54.2,0,0,0-8.71,7.36,55,55,0,0,0-8.33,11.19c-5,8.67-6.31,17.79-7.3,24.19-.45,3.23-.67,5.86-.79,7.68,0,.87-.09,1.57-.13,2.09A3.81,3.81,0,0,1,90.78,449Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.26,371.68c-10,6-9.94,11.5-8.28,16.68s7.79,8.76,12.87,6.83c2.87-1.1,4.95-3.59,6.73-6.1s3.44-5.19,5.93-7,6.1-2.49,8.6-.71",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.26,371.68c-10,6-9.94,11.5-8.28,16.68s7.79,8.76,12.87,6.83c2.87-1.1,4.95-3.59,6.73-6.1s3.44-5.19,5.93-7,6.1-2.49,8.6-.71"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M36.79,378.28c2.61-3.6,9.06-4.65,13.13-2.85s7,5.37,9.72,8.93,5.27,7.32,9,9.8,8.86,3.38,12.55.88a10.78,10.78,0,0,0,4.26-7.38,24.57,24.57,0,0,0-.59-8.7c-.88-4.18-2.32-8.56-5.67-11.21-3.73-3-8.91-3.11-13.67-2.95-5.47.18-11,.59-16.14,2.48s-10.37,6-12.55,11",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.49,441s0-.07,0-.22,0-.38,0-.64c0-.6-.05-1.43-.09-2.48-.06-2.19-.15-5.29-.26-9.11s-.27-8.42-.55-13.5-.66-10.65-1.43-16.46a52,52,0,0,0-1.66-8.36,43.9,43.9,0,0,0-6.91-13.38,39.34,39.34,0,0,0-4.22-4.62,30.92,30.92,0,0,0-7.46-5.09c-.49-.23-.92-.45-1.3-.6l-1-.38L57,366l-.2-.1.21.06.62.2,1,.34c.39.14.82.35,1.32.56a30,30,0,0,1,7.61,5,39.09,39.09,0,0,1,4.29,4.64,42.29,42.29,0,0,1,3.93,6.09,43.15,43.15,0,0,1,3.11,7.38,52.64,52.64,0,0,1,1.68,8.43c.77,5.83,1.14,11.42,1.4,16.5s.38,9.67.46,13.52.11,7,.12,9.11v2.48c0,.26,0,.47,0,.64S82.5,441,82.49,441Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.08,445.55A28.15,28.15,0,0,1,85,441.27a45.1,45.1,0,0,1-.46-12,80.47,80.47,0,0,1,3.8-17.47c2-6.42,4.83-13.29,7.21-20.67a92.88,92.88,0,0,0,2.86-10.93,96.6,96.6,0,0,0,1.42-10.43,153,153,0,0,0,.32-17.84c-.18-5.09-.45-9.19-.62-12-.08-1.4-.14-2.5-.19-3.28,0-.35,0-.63,0-.85v-.29a1,1,0,0,1,0,.29c0,.21,0,.49.08.85.07.77.16,1.87.28,3.26.22,2.84.54,7,.75,12a147.51,147.51,0,0,1-.22,17.88,94.51,94.51,0,0,1-1.4,10.48,93.86,93.86,0,0,1-2.87,11c-2.38,7.4-5.17,14.26-7.23,20.65a81.1,81.1,0,0,0-3.88,17.38,46.77,46.77,0,0,0,.31,12c.24,1.39.47,2.48.67,3.2.08.34.15.62.2.82A1.28,1.28,0,0,1,86.08,445.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.82 450.06 63.97 450.06 62.9 441.04 110.82 441.04 110.82 450.06",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.99 449.03 74.85 476.09 100.31 476.09 105.79 449.03 68.99 449.03",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.82,450.06c0,.12-10.3.19-23,.16s-23-.17-23-.29,10.3-.19,23-.16S110.82,449.94,110.82,450.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.78,463.41a19.25,19.25,0,0,0-4.13-2.36,14.74,14.74,0,0,0-5-1,17.71,17.71,0,0,0-6.16,1.13c-2.14.73-4.13,1.57-6.08,2a14.47,14.47,0,0,1-5.24.16,11.19,11.19,0,0,1-3.38-1.07,6.9,6.9,0,0,1-.81-.52,1.22,1.22,0,0,1-.26-.22s.4.23,1.15.58a11.55,11.55,0,0,0,3.34.91,14.61,14.61,0,0,0,5.11-.24c1.88-.47,3.87-1.32,6-2.05a17.54,17.54,0,0,1,6.33-1.12,14.34,14.34,0,0,1,5.12,1.13,13.05,13.05,0,0,1,3.06,1.78,5.88,5.88,0,0,1,.72.63C102.71,463.32,102.79,463.4,102.78,463.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.42,465.22a20.06,20.06,0,0,0-4-2.33,13.55,13.55,0,0,0-4.84-1,17.51,17.51,0,0,0-6,1.07c-2.06.69-4,1.49-5.85,2a15,15,0,0,1-5,.57,8.39,8.39,0,0,1-3.31-.89,6.6,6.6,0,0,1-.78-.49c-.17-.13-.26-.21-.25-.22s.39.23,1.11.56a9.23,9.23,0,0,0,3.25.72,15.31,15.31,0,0,0,4.91-.64c1.81-.51,3.74-1.32,5.82-2a17.2,17.2,0,0,1,6.12-1.06,13.23,13.23,0,0,1,5,1.12,12.87,12.87,0,0,1,2.93,1.77,7.73,7.73,0,0,1,.7.61Q102.44,465.21,102.42,465.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.24,461.62a21.41,21.41,0,0,0-4.23-2.5,15.71,15.71,0,0,0-5.15-1.23A16.64,16.64,0,0,0,87.5,459a56.54,56.54,0,0,1-6.29,2.05,15.86,15.86,0,0,1-5.42,0,12,12,0,0,1-3.48-1.1,6,6,0,0,1-.85-.53c-.18-.13-.27-.21-.26-.22s.41.24,1.18.59a13.38,13.38,0,0,0,3.46.95,16.37,16.37,0,0,0,5.29-.1,65.53,65.53,0,0,0,6.22-2.07,16.6,16.6,0,0,1,6.54-1.11,15.64,15.64,0,0,1,8.37,3.24,7.77,7.77,0,0,1,.75.64C103.17,461.52,103.25,461.61,103.24,461.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.24,450.1c0,.12-10.54.22-23.54.22s-23.54-.1-23.54-.22,10.53-.22,23.54-.22S111.24,450,111.24,450.1Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470.25,476.09c0,.14-98.62.26-220.24.26s-220.26-.12-220.26-.26,98.6-.26,220.26-.26S470.25,475.94,470.25,476.09Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.dc8125a7a57fc79ff090008f1d1c3198.svg";
export { ForwardRef as ReactComponent };